/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Project Team from
 * https://undraw.co
 */

function Icon({ size, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 1137.68 859.71" {...props}>
      <defs>
        <linearGradient
          id="prefix__a"
          x1={512.79}
          y1={730.45}
          x2={512.79}
          y2={139.36}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={703.39}
          y1={781.93}
          x2={703.39}
          y2={171.12}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__c"
          x1={876.05}
          y1={827.31}
          x2={876.05}
          y2={239.74}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__d"
          x1={479.8}
          y1={818.68}
          x2={479.8}
          y2={229.88}
          gradientTransform="matrix(-1 0 0 1 828.87 0)"
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__e"
          x1={561.7}
          y1={875.44}
          x2={561.7}
          y2={737.82}
          xlinkHref="#prefix__a"
        />
      </defs>
      <title>team spirit</title>
      <path
        d="M12.28 406.51c18 70.15 56.11 130.79 116.34 160.18 125.22 61.09 407.45 29.58 618.12-6.58 109-18.71 204.74-70.3 274.33-143zM1117.05 76.32h-115.59c-5.5 0-10-4.1-10-9.11s4.49-9.11 10-9.11h20c-5.5 0-10-4.1-10-9.11s4.49-9.1 10-9.1h-14.27c-5.5 0-10-4.1-10-9.11s4.49-9.11 10-9.11h60.33c-13.39-5.68-29-9.71-47.06-11.82-164.51-19.27-223.25-6.53-244 6.58a242.11 242.11 0 01-84.55 33.79c-101.5 19.09-291.32 42.06-463.37-7.36-85.51-24.55-149.06 17-187.16 86.31h1095.74c-1.43-20.16-5.71-38.78-13.57-55.07a10.48 10.48 0 01-6.5 2.22zM2.47 260.09a423.94 423.94 0 004.49 122.39l1014.88 33.84a433.15 433.15 0 0070.51-98zm401.37 87.31h-20c5.49 0 10 4.1 10 9.11s-4.5 9.1-10 9.1H268.3c-5.49 0-10-4.09-10-9.1s4.5-9.11 10-9.11h20c-5.49 0-10-4.1-10-9.11s4.5-9.11 10-9.11h-14.29c-5.49 0-10-4.09-10-9.1s4.5-9.11 10-9.11H389.6c5.5 0 10 4.1 10 9.11s-4.49 9.1-10 9.1h14.24c5.5 0 10 4.1 10 9.11s-4.47 9.11-10 9.11zM1137.17 129.8l-1108 24.57c-13.5 31.59-22.43 67.3-26.55 104.32h1115.13a399 399 0 0016.1-66.49c3.32-21.76 4.65-42.8 3.32-62.4zm-909.58 80.51h-20c5.49 0 10 4.1 10 9.11s-4.5 9.11-10 9.11H92.01c-5.49 0-10-4.1-10-9.11s4.5-9.11 10-9.11h20c-5.49 0-10-4.09-10-9.1s4.5-9.11 10-9.11H97.72c-5.49 0-10-4.1-10-9.11s4.5-9.11 10-9.11h115.59c5.5 0 10 4.1 10 9.11s-4.49 9.11-10 9.11h14.28c5.49 0 10 4.1 10 9.11s-4.51 9.1-10 9.1z"
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={664.34}
        cy={749.94}
        rx={75.23}
        ry={16.89}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={839.15}
        cy={803.58}
        rx={135.72}
        ry={11.14}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={294.22}
        cy={786.69}
        rx={135.72}
        ry={16.89}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={501.15}
        cy={702.14}
        rx={102.12}
        ry={16.89}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={529.66}
        cy={842.82}
        rx={81.75}
        ry={16.89}
        fill="#6c63ff"
        opacity={0.1}
      />
      <path
        d="M608.62 320.47c-2.16-14.54-15.37-48.47-15.37-48.47-.23-1-.49-2-.78-3-9.37-32.2-22.34-35-22.34-35l-46.46-10a3.6 3.6 0 011 .93 6.45 6.45 0 00-.73.11 18.2 18.2 0 01-4.07-8.8c-.09-.48-.17-1-.23-1.49a32.68 32.68 0 00-2.66-49.13c-.49-.38-1-.75-1.49-1.1 2.19-2.33 2.26-5.57.62-8.81-3.66-7.6-11.62-12.41-19.8-14.76-6.25-1.79-13-2.37-19.22-.41-3.53 1.12-6.75 3-10.06 4.67-6.17 3.08-13 5.52-17.61 10.59-1.08 1.18-2.08 2.69-1.76 4.25.24 1.16 1.16 2.06 1.75 3.09 1.33 2.31 1 5.22.09 7.74s-2.24 4.86-2.87 7.44-.39 5.62 1.55 7.47a32.91 32.91 0 002.9 2 15.21 15.21 0 012.77 3.11q2.76 3.7 5.5 7.43a76.54 76.54 0 016.89 10.47c1.37 2.7 2.43 5.58 4.26 8a11.86 11.86 0 001.83 1.92l-.54-.21a8.33 8.33 0 006.11 2.49h.28a1.68 1.68 0 001.12-.46v1c.11 3.57.09 7.37-.16 10.94l-.43-.22a3.75 3.75 0 00-4 .42L431.94 267s-9.3 12.72-8 34.68l-7.5 32.93s-9.37 27.94-2.16 47.89 11.39 31.36 11.39 31.36 2.88 22.67 7.21 24.52 6.2 2.85 6.2 2.85l.86 5.42s.29.53.8 1.42c3.15 5.48 14.82 24.82 21.6 22.75a86.69 86.69 0 011.1 15.89l6.71 45.05s4.68 12.25 4.39 18.67S480 566 480 566a29.75 29.75 0 00-2.88 20.95c2.74 12 6.2 67.28 6.2 67.28l5 13.4-.14 15.71a15 15 0 01-3.1 7c-3.24 3.52-3 7.59-10.81 12.4s-12.76 6.63-12.76 13a16.72 16.72 0 01-.24 2.65c-.72 4.68-2.12 7.22 12.24 8.58 16.87 1.6 28.12-9.4 28.12-9.4s2.48-4.5 14.16-6.32c0 0 4-.21 4.21-3.74.08-1.22.06-3.55 0-6.12-.19-4.89-.66-10.6-1.28-10.88-.78-.35-2.14-5.27-2.61-7.05h3.25s3-22.67 0-37.35-.29-25.09-.29-25.09l-.58-38.77s-4-4.28-.86-11.84 0-44.9 0-44.9 1.16-13.4 4.47-16.54.16-19.63 0-20.49l5.9 19.79s2.59 39.34 8.08 46.46l1.58 17.82s11.24 16.4 9.08 25.23 2.31 40.77 2.31 40.77v32.65s-5.05 13.11 2 17.82l3-.12c-1 .93-1.77 2.33-2.94 3.54-1.35 1.39-2.12 6.68-2.55 11.23-.36 3.85-.48 7.16-.48 7.16s3 4.8 8.65 5.13S581 730.45 581 730.45s18.39 0 23.15-1l.28-.07a6.25 6.25 0 003.59-2.93 7.5 7.5 0 00.86-5.39c-.59-2.81-2.82-5.89-7.76-8.51C588.83 706.07 587 700 587 700l-8.07-12.11h1.15s-.71-12.83 8.07-27.23l-.57-63.43s3.6-21.81-2.59-33.65c0 0-.51-12.54 3.63-16.39s-5.51-42.76-5.51-42.76-2-20.89-4.35-39.95c9.73 9.23 19.82-24 21.52-29.91h.25l-.11-.43c.07-.28.11-.42.11-.42s-2.16-7.68-.58-6.12 5.48-4.28 5.48-4.28-.58-31.79 6.2-47.81-3.01-55.04-3.01-55.04zm-29 20.23l.05-.09c1 19.41-.19 60.83-.19 60.83s-1.34 5.31-2.77 11.56l-1-39.35-1-37.07zm-124.11-13.38s4.9 61.29 0 70.13c-1.39 2.52-2.56 7-3.53 12.11-1.62-4.25-5.05-14.23-3.82-19.52 1.59-6.84-3.17-24.81-3.17-25.23s-.43-10 3-17.32 1.18-10.49 1.18-10.49 2.88-12 6.34-9.68z"
        transform="translate(-31.16 -20.14)"
        fill="url(#prefix__a)"
      />
      <path
        d="M436.29 445.22c-4.27 18.77-21.25-9.61-25.12-16.42-.5-.89-.78-1.41-.78-1.41l1.84-8.63 9.73-4a27.18 27.18 0 014.36 2.84c5.33 4.19 13.26 13.08 9.97 27.62zM568.02 414.51s0 .14-.11.42c0 .12-.08.28-.13.45-1.67 5.86-11.57 38.85-21.13 29.69-10.46-10-5.38-33.12-5.38-33.12h.07l22-2.25 4.36 4.48z"
        fill="#d38884"
      />
      <path
        d="M555.29 576.86l.56 63c-8.63 14.3-7.92 27-7.92 27l-28.44 1.12c-6.94-4.67-2-17.68-2-17.68v-32.44s-4.39-31.69-2.27-40.47-8.91-25-8.91-25l-1.56-17.69c-5.38-7.07-7.93-46.12-7.93-46.12l-5.77-19.72c.16.85 3.16 17.31 0 20.34s-4.39 16.41-4.39 16.41 3.11 37.08 0 44.57.84 11.75.84 11.75l.57 38.49s-2.69 10.33.28 24.9 0 37.08 0 37.08h-30.51l.14-15.71-4.94-13.3s-3.4-54.9-6.09-66.79a29.84 29.84 0 012.82-20.8s-5.65-9.05-5.37-15.42-4.36-18.52-4.36-18.52l-6.58-44.71a86.86 86.86 0 00-3.26-25.47c-3.82-12.74-9.48-29.44-9.48-29.44l6.39.57 32.24 2.87s78.39-5.27 81.9-.89a14.71 14.71 0 011.48 4.57c3.52 15.81 8.17 65.34 8.17 65.34s9.48 38.63 5.41 42.45-3.57 16.26-3.57 16.26c6.1 11.75 2.55 33.45 2.55 33.45z"
        fill="#444053"
      />
      <path
        d="M489.02 686.29c-.22 3.51-4.13 3.72-4.13 3.72-11.46 1.8-13.9 6.26-13.9 6.26s-11 10.93-27.59 9.34c-14.1-1.36-12.73-3.87-12-8.52a17.62 17.62 0 00.23-2.62c0-6.37 4.88-8.18 12.52-13s7.43-8.81 10.61-12.31 3.51-10.29 3.51-10.29c3.6-6.27 12.73 1 12.73 1 .43 2.22 14 1.91 14 1.91s1.8 7.22 2.73 7.64c.61.28 1.07 5.94 1.25 10.8.1 2.55.12 4.86.04 6.07z"
        fill="#b07473"
      />
      <path
        d="M489.02 686.29c-.22 3.51-4.13 3.72-4.13 3.72-11.46 1.8-13.9 6.26-13.9 6.26s-11 10.93-27.59 9.34c-14.1-1.36-12.73-3.87-12-8.52 6.3 1.56 18.34 3.74 25.37-.08 9.77-5.3 16.78-9 16.78-9l15.44-7.77c.09 2.53.11 4.84.03 6.05z"
        opacity={0.1}
      />
      <path
        d="M575.39 705.18a6.1 6.1 0 01-3.52 2.91l-.27.07c-4.67 1-22.72 1-22.72 1s-18.25-14.11-23.77-14.43-8.49-5.1-8.49-5.1.11-3.28.46-7.1c.43-4.52 1.18-9.77 2.51-11.15 2.44-2.55 3-6 8.49-3.82 0 0 7.84-13.82 17.08-3.14l9.56 14.5s1.8 6 13.91 12.51c4.84 2.6 7 5.66 7.61 8.45a7.45 7.45 0 01-.85 5.3z"
        fill="#b07473"
      />
      <path
        d="M575.39 705.18c-1.08.91-2.27 1.89-3.52 2.91l-.27.07c-4.67 1-22.72 1-22.72 1s-18.25-14.11-23.77-14.43-8.49-5.1-8.49-5.1.11-3.28.46-7.1c5.62 1.68 14.13 4.65 16.41 7.85 3.5 4.87 14.13 11.67 14.13 11.67s19.82-1.91 28.62-2.17a7.45 7.45 0 01-.85 5.3z"
        opacity={0.1}
      />
      <path
        d="M498.26 211.39l-26.1 27.59s-31.63-2.33-26.11-11.67c2.81-4.76 3.25-14.72 3-23.38-.23-8.35-1.09-15.46-1.09-15.46s44.36-22.08 41-1.49a33.89 33.89 0 00-.12 11.75c1.89 10.4 9.42 12.66 9.42 12.66z"
        fill="#d38884"
      />
      <path
        d="M488.92 186.98a33.89 33.89 0 00-.12 11.75 32.56 32.56 0 01-23.22 9.69c-6 0-12.49-4.93-17.34-7.78-.23-8.36-.28-12.17-.28-12.17s44.36-22.08 40.96-1.49z"
        opacity={0.1}
      />
      <path
        d="M498.26 174.03a32.69 32.69 0 11-12.3-25.54 32.69 32.69 0 0112.3 25.54z"
        fill="#d38884"
      />
      <path
        d="M542.73 419.36c-8.14 19.37-60.5 19.77-60.5 19.77v-21.12l-3.17-.21c1.37 6.05-1.92 20.8-1.92 20.8-41.38 5.84-51.47-17.74-51.47-17.74l1.44-8.07 32.24 2.87s78.39-5.27 81.9-.89a14.71 14.71 0 011.48 4.59z"
        opacity={0.1}
      />
      <path
        d="M482.23 436.58v-21.12l-3.17-.2c1.37 6-1.92 20.8-1.92 20.8-31.14 4.39-44.56-7.87-49.29-14.21a19.35 19.35 0 01-2.18-3.52l12.64-71.1 3-104.64 4.53-18.36 1.05-8.81v-.1h.11l3.22 1.38 19.27 8.33 21.89-16.53.32-.23 1.09-.83 1.81 1.45 4.5 3.61 14.43 93.19s25 71.75 29.68 100.71c.19 1.16.34 2.24.46 3.25 3.09 26.44-61.44 26.93-61.44 26.93z"
        fill="#6c63ff"
      />
      <circle cx={471.83} cy={227.09} r={1.86} fill="#67647e" />
      <circle cx={472.69} cy={244.07} r={1.86} fill="#67647e" />
      <circle cx={474.55} cy={271.56} r={1.86} fill="#67647e" />
      <circle cx={477.62} cy={301.17} r={1.86} fill="#67647e" />
      <circle cx={479.48} cy={328.97} r={1.86} fill="#67647e" />
      <circle cx={481.34} cy={358.58} r={1.86} fill="#67647e" />
      <circle cx={480.6} cy={387.87} r={1.86} fill="#67647e" />
      <path
        d="M448.13 357.57s-2.08 27.23-5.9 35.15-5.52 30.14-5.52 30.14l-8.87-1a19.35 19.35 0 01-2.18-3.52l12.64-71.1 3-104.64 4.54-18.37 1.05-8.81.12-.05a3.58 3.58 0 013.16.05l.42.22q-.19.54-.36 1.11c-3.46 10.83-4.75 30.79-4.75 30.79s5 36.51 5.52 53.49-2.87 56.54-2.87 56.54z"
        opacity={0.1}
      />
      <path
        d="M426.32 417.63a5.13 5.13 0 01-.34.66c-3.44 5.81-12.16 9.5-14.81 10.51-.5-.89-.78-1.41-.78-1.41l1.84-8.63 9.73-4a27.18 27.18 0 014.36 2.87z"
        opacity={0.1}
      />
      <path
        d="M402.75 278.67l-8.07 4.81-7.35 32.69s-9.2 27.73-2.13 47.54 11.18 31.15 11.18 31.15 2.83 22.5 7.08 24.34 6.08 2.83 6.08 2.83l.85 5.38s11.52-3.91 15.59-10.8-3-24-3-24-6.08-14.58-4.52-21.37-3.12-24.62-3.12-25-.42-9.91 3-17.2 1.14-10.4 1.14-10.4l-2.13-20.8z"
        fill="#67647e"
      />
      <path
        d="M543.4 413.24s-21.37 8.06-28.16 1-6.09-40.19-6.09-40.19-6.5-61.13-10.61-71.17-2-82.5-2-82.5-2.76-9.37-5.17-11.82a2.62 2.62 0 00-.51-.41l.83.18 2.9.62 4.5 3.61 14.43 93.19s25 71.75 29.68 100.71z"
        opacity={0.1}
      />
      <path
        d="M568.02 415.36h-.24c-2.69.35-26.43 3.22-26.53-1.72a14.47 14.47 0 01.09-1.71l22-2.25 4.36 4.48c.08.29.14.54.2.74z"
        opacity={0.1}
      />
      <path
        d="M545.24 245.93l15.6 8.14s13 33.66 15.08 48.09c0 0 9.63 38.66 3 54.56s-6.08 47.46-6.08 47.46-3.82 5.8-5.38 4.25.57 6.08.57 6.08-26.67 3.54-26.78-1.7 6.12-30.28 6.12-30.28 1.7-59.57-.71-68.91-1.42-67.69-1.42-67.69z"
        fill="#67647e"
      />
      <path
        d="M498.69 309.38s-8.78 21.5-11.61 22.92.57 7.07.57 7.07 15.99-22.35 11.04-29.99zM493.45 233.96c.1-.41-10.47 10.37-13.3 12s10.33-.1 13.3-12zM464.02 307.68s-16.13 10.43-14 14.56 14-14.56 14-14.56zM493.31 459.93s13.73 8.83 35.09 11zM460.34 481.16s12.73 16 18.54 16.41-18.54-16.41-18.54-16.41zM478.17 543.86c-.57.28-7.22 14.43-14 14.86s14-14.86 14-14.86zM537.17 574.86s12.62-2.83 15.43 6.22c0-.03-.85-2.86-15.43-6.22zM528.68 626.62s15.29-3.12 18.54 1.13-18.54-1.13-18.54-1.13zM485.43 633.86c0 .14-15.56 3.12-15 5.1s16.6 1.7 17.17-1.42a3 3 0 00-2.17-3.68zM523.59 647.28s25.57-3.12 24 2.26-24-2.26-24-2.26zM389.73 332.3c.14.42 16.84 2.69 19.1 8.07 0 0-16.41-7.65-19-7.65M413.22 376.02s-13.87 4.39-12.88 11-1.41-3.06 12.88-11zM406.76 409.7s5.05-6.93 9.86-5.66-9.86 5.66-9.86 5.66zM485.96 148.49a7.87 7.87 0 01-1.62 1.21c-4 2.33-5.1 5.92-7 10.06-1.77 3.79-3.72 7.8-7.29 9.95-4.61 2.78-10.68 1.76-15.47 4.18a12 12 0 00-6.4 11.83 34.12 34.12 0 001.36 5.42 38.65 38.65 0 011.46 11.77 2 2 0 010 .35 32.68 32.68 0 1135-54.77z"
        opacity={0.1}
      />
      <path
        d="M485.11 138.65c-3.59-7.54-11.4-12.32-19.43-14.65-6.13-1.77-12.79-2.35-18.87-.4-3.47 1.1-6.62 3-9.87 4.63-6.06 3.06-12.72 5.48-17.28 10.51-1.07 1.17-2 2.67-1.73 4.22.23 1.15 1.13 2 1.71 3.06 1.31 2.3 1 5.19.09 7.69s-2.2 4.82-2.82 7.39-.38 5.58 1.52 7.41c.85.81 1.94 1.32 2.86 2a15.05 15.05 0 012.71 3.08l5.4 7.38a74.85 74.85 0 016.76 10.39c1.34 2.68 2.38 5.54 4.18 7.93s4.6 4.31 7.58 4.05a1.47 1.47 0 001.2-.57 1.58 1.58 0 00.15-.75 38.38 38.38 0 00-1.43-11.73 33.85 33.85 0 01-1.36-5.42 12.05 12.05 0 016.4-11.83c4.8-2.42 10.87-1.4 15.47-4.17 3.58-2.16 5.53-6.17 7.29-10 1.93-4.14 3-7.73 7-10.06s4.46-6.19 2.47-10.16z"
        fill="#585268"
      />
      <path
        d="M470.47 672.92s5 6.37 3.7 10-3.7-10-3.7-10zM538.12 688.86s1.11-8.54 5.56-8.62 4.67-.46 8.07.85 6.59 3.34 5.57 3.64-5.85-4.88-10.81-2.23a35.72 35.72 0 00-8.39 6.36zM455.55 235.74l14-9.81s-20.48-12.1-22.92-10.4-4.12 17-4.12 17z"
        opacity={0.1}
      />
      <path
        d="M455.49 235.11l14-10s-20.48-12.1-22.92-10.4-4.12 17.84-4.12 17.84z"
        fill="#e1e7ef"
      />
      <path
        d="M455.49 235.11l14-10s-20.48-12.1-22.92-10.4-4.12 17.84-4.12 17.84z"
        fill="#6c63ff"
      />
      <path
        d="M448.89 214.79l-.42-.21a3.63 3.63 0 00-3.93.41l-42 34.07s-9.13 12.63-7.86 34.42l24.77 35.09s2.83-11.88 6.22-9.62c0 0 4.81 60.85 0 69.62s-6.93 41.6-6.93 41.6l16.27 1.84s1.7-22.22 5.52-30.14 5.9-35.15 5.9-35.15 3.44-39.56 2.87-56.54-5.52-53.49-5.52-53.49 1.39-21.4 5.11-31.9z"
        fill="#67647e"
      />
      <path
        d="M490.73 229.54l-17.45-6.46s22.22-24.34 25-10.84z"
        opacity={0.1}
      />
      <path
        d="M490.73 228.69l-17.45-6.46s22.22-24.34 25-10.84z"
        fill="#e1e7ef"
      />
      <path
        d="M490.73 228.69l-17.45-6.46s22.22-24.34 25-10.84z"
        fill="#6c63ff"
      />
      <path d="M490.16 207.98a1 1 0 01.72.16z" opacity={0.1} />
      <path
        d="M491.84 206.29l46.3 10s12.74 2.83 21.94 34.81-12.6 71.16-12.6 71.16l-4.81-4.09 2.41 93.39s-21.37 8.06-28.16 1-6.08-40.22-6.08-40.22-6.51-61.12-10.62-71.17-2-82.49-2-82.49-3.78-12.95-6.38-12.39z"
        fill="#67647e"
      />
      <path
        d="M534.2 265.8c-.65.6-1.41 28.86 1.42 50.37a274.5 274.5 0 008 38.77l-4.2-86.17s-3.24-4.81-5.22-2.97zM528.54 241.46c1.13.71 6.09 12.45 3.82 17.26s-3.82-17.26-3.82-17.26zM484.84 138.65a25.56 25.56 0 00-10.18-10.66 24.21 24.21 0 017.63 9c2 4 1.41 8-2.48 10.19s-5.1 5.92-7 10.06c-1.77 3.79-3.72 7.8-7.3 10-4.6 2.78-10.67 1.75-15.47 4.17a12.08 12.08 0 00-6.4 11.84 34 34 0 001.37 5.41 38.68 38.68 0 011.46 11.77 1.58 1.58 0 01-.16.75 1.43 1.43 0 01-1.19.57 6.89 6.89 0 01-3.49-.65 8.12 8.12 0 006 2.35 1.18 1.18 0 001.34-1.32 38.37 38.37 0 00-1.45-11.77 32.85 32.85 0 01-1.37-5.42 12.05 12.05 0 016.4-11.83c4.8-2.42 10.87-1.4 15.47-4.17 3.58-2.16 5.53-6.17 7.29-10 1.93-4.14 3-7.73 7-10.06s4.53-6.26 2.53-10.23z"
        opacity={0.1}
      />
      <path
        d="M800.87 284.37c-13.78-.27-25.94-10-32.83-21.89a22 22 0 01-3.32-9.37 10.82 10.82 0 01.38-2.24 23.24 23.24 0 001-3.43 6 6 0 000-1.4v-.08c.33-2.53-1.16-5-3-6.73s-4.15-3-6.07-4.72c-5.92-5.2-7.72-13.54-7.83-21.48v-.42c.07-3.4.34-6.81.31-10.21a42.93 42.93 0 00-.25-5.78c-.57-4.81-2.4-9.71-6.18-12.78-9.86-8-26.44.33-36.65-7.23-2.48-1.85-4.49-4.58-7.5-5.3-2.27-.55-4.63.19-6.85.93-7.52 2.48-15.91 5.74-18.85 13-1.68 4.17-1.21 8.93-2.75 13.15-1 2.83-2.91 5.26-4.3 7.94a12.43 12.43 0 00-1.6 6.63 7.48 7.48 0 00.49 3.53 9 9 0 002.45 3.51 11.65 11.65 0 01-1.46 2.34c-1.92 2.35-4.87 4-6.87 6.34-3.7 4.29-3.56 10.12-1.74 15.16s5.11 9.63 7.38 14.54c1 2.13 1.76 4.51.75 6.63-.71 1.47-2.18 2.59-3.32 3.86a12.13 12.13 0 00-3 6.7c-22.51 5.14-22.53 23.23-22.53 23.23l-12.16 30.58s-1.95 5.15-4.24 11.95l-14.39-2.58 10 16.74c-1.89 6.82-3.23 13.14-2.79 16.32 0 0-4.47 21 3.48 24.67l17.54 7.89a10.39 10.39 0 002.43 1.09l.71.32a1.88 1.88 0 001.64 0h.24a2.36 2.36 0 001-.15 2 2 0 00.88-.95.3.3 0 010-.1l5.25-1.52 4.45 5.27c2 1.41 4 2.63 5.89 3.73l-6.89 68.42s-1.11 91-4.47 111.74c-1.24 7.68-1.25 12.92-.78 16.48l-.13.22c.83 5.85 3 7 3 7v-.08a.65.65 0 00.13.08 58.91 58.91 0 013.6-7.72v1.5c-.07 7.72-.31 18.53-1.11 25.56-1.36 12 3.48 51.55 3.48 51.55l1.67 36a33.28 33.28 0 01-4.1 17.54c-4 7.19-9.11 17.31-9.48 21.8a4.5 4.5 0 000 .73L633 773.2s-3.35 5.18 4.22 7.27c4.07 1.13 11.09 0 16.73-1.33a11.18 11.18 0 008.67-10.88 38.5 38.5 0 017.08-13.59l1.41 8.29 9.44 2.34 1.21-22.72a10 10 0 00.65-4c1.86-16.16-4.38-14.71-4.38-14.71a.87.87 0 01.3.56l-.3-.55c-3.83-7.56-2-20-2-20s5-36 6.71-45.51c1.23-6.72.72-28.72.31-41 0-.51 0-1-.05-1.49 14.64-.19 32.58-.68 45.17-1.9v1.48l-2.32 85.05a46.69 46.69 0 01-3.26 15.82c0 .1-.07.19-.11.29a69 69 0 00-4.61 22.29l-1.08 27v.75c-1.88.72-4.85 2.81-4.93 8.87-.13 8.88 15.52 5.92 15.52 5.92 15.64 0 15.77-16.28 15.77-16.28s.49-14.93 1.24-24.92-2.36-7.79-2.36-7.79l-.24 28.42v.22-24.91l.24-3.61v-.87L744 702.4s14.41-48.84 16.64-58.21c1.59-6.66.93-26.72.41-37.81 0-.51 0-1-.08-1.47 4.47-.4 8.42-.44 10-.44h.73s-.74-78.44-2.61-108-4.84-56.61-12.29-64.75c-4.5-4.92-10.77-20.11-15-31.36a156.88 156.88 0 0027.57 9c23.59 4.94 20.36-15.54 20.36-15.54l-2.39-38.73h.16a197.48 197.48 0 00-2.6-30.28c-1.25-7.68-3.16-15.62-6.08-22 2.56-1 5.09-2.07 7.57-3.17 6.41-2.83 13.63-6.84 14.55-13.75h-.31a8.92 8.92 0 00.24-1.52zm-146.23 56c.05 4-.1 10.94-.34 18.61l-7.49-10 7.51-12.18zM755 360.68zm3.12 15.13l-12.48-4a56 56 0 017.71-9.54l1.08-1-.39.08.6-.55.36-.08-.57.55.68-.14a21.29 21.29 0 004.25 8.55c4.48 4.89-1.23 6.13-1.23 6.13z"
        transform="translate(-31.16 -20.14)"
        fill="url(#prefix__b)"
      />
      <path
        fill="#a27772"
        d="M651.15 715.66l-1.46 27.68-9.31-2.33-1.96-11.51 12.73-13.84z"
      />
      <path
        opacity={0.1}
        d="M651.15 715.66l-1.46 27.68-9.31-2.33-1.96-11.51 12.73-13.84z"
      />
      <path
        d="M685.32 747.01l14.2 2.94 10.53-9.3v-26.21l.24-3.58v-.87l1.96-29.13s14.21-48.49 16.42-57.8c1.56-6.6.91-26.52.39-37.53-.21-4.51-.39-7.53-.39-7.53l-31.35-7.59-.66 24.1-2.29 84.44a46.79 46.79 0 01-3.21 15.71l-.11.29a68.72 68.72 0 00-4.55 22.12l-1.06 26.85v.74z"
        fill="#cc818c"
      />
      <path
        d="M710.29 710.01v.74-.76zM685.32 747.01l14.2 2.94 10.53-9.3v-2.23a3 3 0 01-1.51 2.4l-.15.09a28.3 28.3 0 01-15.94 3.15l-5.54-.47a5.19 5.19 0 00-1.47.36v.74z"
        opacity={0.1}
      />
      <path
        d="M708.39 741.64l.15-.08a3 3 0 001.53-2.6l.23-28.21s3.06-2.19 2.32 7.73-1.22 24.74-1.22 24.74-.12 16.16-15.55 16.16c0 0-15.43 2.94-15.31-5.88s6.37-9.18 6.37-9.18l5.54.48a28.23 28.23 0 0015.94-3.16z"
        fill="#b07473"
      />
      <path
        d="M611.36 741.01c.36 6.37 19.1 2.69 19.1 2.69l12.61-24.48s10.53-8.09 5.26-15.19a11.33 11.33 0 01-.77-1.21l-.05-.06c-.11-.18-.21-.37-.31-.57-3.78-7.5-1.92-19.8-1.92-19.8s4.89-35.76 6.61-45.19c1.21-6.66.71-28.51.31-40.73-.16-5.08-.31-8.49-.31-8.49l-31.11-8.33v9.28c-.07 7.67-.31 18.4-1.1 25.38-1.34 11.87 3.43 51.18 3.43 51.18l1.65 35.77a33.13 33.13 0 01-4 17.41c-3.9 7.14-9 17.2-9.35 21.65a4.38 4.38 0 00-.05.69z"
        fill="#cc818c"
      />
      <path
        d="M611.36 741.01c.36 6.37 19.1 2.69 19.1 2.69l12.61-24.48s10.53-8.09 5.26-15.19a11.33 11.33 0 01-.77-1.21c-.17 3.71-4.24 13-4.24 13s-10.41 20.83-13.72 25.6-17.69-.89-18.23-1.09a4.38 4.38 0 00-.01.68z"
        opacity={0.1}
      />
      <path
        d="M647.2 702.16s6.16-1.43 4.32 14.61a10.33 10.33 0 01-4.87 9.17c-4.41 2.77-11.21 8.73-14.65 20.32a11.08 11.08 0 01-8.55 10.8c-5.56 1.3-12.49 2.44-16.5 1.32-7.47-2.08-4.16-7.22-4.16-7.22l8.57-10.17s14.94 5.88 18.24 1.1 13.72-25.59 13.72-25.59 5.71-12.99 3.88-14.34z"
        fill="#b07473"
      />
      <path
        d="M697.32 573.38l-.66 24.1c8.35-.81 14.33-1.94 15.35-3.53 2.21-3.42 10.23-4.86 17.05-5.45-.21-4.51-.39-7.53-.39-7.53zM620.78 591.86a11.44 11.44 0 013.43-4.14c3.3-1.83 2.94 11.76 2.94 11.76s11 .1 25.05-.08c-.16-5.08-.31-8.5-.31-8.5l-31.11-8.32s.06 3.86 0 9.28z"
        opacity={0.1}
      />
      <path
        d="M617.23 595.08s3.68-10 7-11.78 2.94 11.75 2.94 11.75 80.82.74 84.86-5.51 27.55-5.88 27.55-5.88-.73-77.88-2.57-107.26-4.77-56.21-12.12-64.29c-4.75-5.23-11.51-22.15-15.69-33.43-2.27-6.16-3.78-10.65-3.78-10.65l-77.14 4.4-.63 6.25-8.19 81.92s-1.1 90.37-4.41 110.94 2.18 23.54 2.18 23.54z"
        fill="#444053"
      />
      <g opacity={0.1}>
        <path d="M705.75 589.54c4-6.24 27.55-5.88 27.55-5.88s-.73-77.88-2.57-107.26-4.77-56.21-12.12-64.29c-4.77-5.25-11.51-22.15-15.69-33.43-1.91-5.18-3.28-9.17-3.66-10.31l6-.34s1.51 4.49 3.79 10.65c4.18 11.28 10.93 28.2 15.68 33.43 7.35 8.08 10.29 34.9 12.12 64.29s2.58 107.26 2.58 107.26-23.51-.36-27.56 5.88c-3.45 5.33-62.92 5.58-80.18 5.53 22.15-.05 70.94-.71 74.06-5.53zM617.95 583.3c1.49-.83 2.23 1.47 2.6 4.26a57.68 57.68 0 00-3.47 7.52s-2.13-1.15-3-7c1.22-2.09 2.57-4.06 3.87-4.78z" />
      </g>
      <path
        d="M641.07 179.6c-5.34 7.28.06 17.63-5.67 24.71-1.89 2.34-4.8 4-6.77 6.3-3.65 4.26-3.51 10.05-1.72 15.05s5 9.56 7.28 14.44c1 2.11 1.74 4.48.74 6.58-.7 1.46-2.15 2.57-3.28 3.83-3.68 4.11-3.78 9.82-1.8 14.66s5.76 9 9.49 13.1c1.47 1.61 3.33 3.39 5.78 3.34a8 8 0 003.63-1.19 37 37 0 0016.84-48.29c-3.1-7.43-8.27-14.55-8.32-22.4 0-6.23 3.2-12.18 3.77-18.38.69-7.54-3.77-19.51-12.87-22.8.6 4.84-4.39 7.31-7.1 11.05z"
        fill="#585268"
      />
      <path
        d="M641.07 179.6c-5.34 7.28.06 17.63-5.67 24.71-1.89 2.34-4.8 4-6.77 6.3-3.65 4.26-3.51 10.05-1.72 15.05s5 9.56 7.28 14.44c1 2.11 1.74 4.48.74 6.58-.7 1.46-2.15 2.57-3.28 3.83-3.68 4.11-3.78 9.82-1.8 14.66s5.76 9 9.49 13.1c1.47 1.61 3.33 3.39 5.78 3.34a8 8 0 003.63-1.19 37 37 0 0016.84-48.29c-3.1-7.43-8.27-14.55-8.32-22.4 0-6.23 3.2-12.18 3.77-18.38.69-7.54-3.77-19.51-12.87-22.8.6 4.84-4.39 7.31-7.1 11.05zM700.29 444.41c-10.69.56-20.75 5.16-30.11 10.36s-18.42 11.09-28.49 14.78M693.65 469.6a44.07 44.07 0 00-27.75 13.5c-2.6 2.75-4.84 5.83-7.55 8.47a33.54 33.54 0 01-14.88 8.43M695.84 488.77a48.52 48.52 0 00-22.32 13.46c-1.64 1.77-3.13 3.66-4.77 5.43-8.85 9.5-21.35 14.54-33.42 19.31"
        opacity={0.1}
      />
      <path
        d="M694.93 222.92a219.46 219.46 0 002.2 25.52c1 6 2.4 11.4 4.41 13.79 5.88 7-28.65 16.35-28.65 16.35l-20.39-15.8s16.16-14.88 8.63-29.39 33.8-10.47 33.8-10.47z"
        fill="#cc818c"
      />
      <path
        d="M627.63 378.68h81.55c-2.27-6.16-3.78-10.65-3.78-10.65l-77.14 4.4z"
        opacity={0.1}
      />
      <path
        d="M622.38 377.21h87.19c-2.45-8.77 0-16.88 3.49-23.12a51.1 51.1 0 019.13-11.84l.6-.55 30.44-6.74 1.64-.36s.25-55.35-19.35-62.95-31.35-17.87-31.35-17.87l-26.93 8.32-19.84-10c-6.37 6.85-23.27 4.16-23.27 4.16-27.67 3.18-27.67 24-27.67 24s16.16 37.71 17.39 37.71-1.47 59.24-1.47 59.24z"
        fill="#6c63ff"
      />
      <path
        d="M652.48 342.02s-17.78-3.94-23.83-10.83M742.13 321.37l-20.62 16.9a35.13 35.13 0 00.68 4l.6-.55 30.44-6.74zM686.3 371.33s4.51 2.54 11.42 5.88h11.85c-2.45-8.77 0-16.88 3.49-23.12l-20.89-6.76c7.11 6.61-5.87 24-5.87 24z"
        opacity={0.1}
      />
      <path
        d="M618.7 273.62l-12.24 6.61-12 30.37s-12.49 33.3-11.27 42.12c0 0-4.4 20.82 3.43 24.49l20.4 9.24a1.9 1.9 0 002.45-2.62c-2.91-5.51-6.11-14.13-1-18.87l-5.88-12.24 21.25-34.78 7.1-12z"
        fill="#6c63ff"
      />
      <path
        d="M645.93 335.07c1.06 4.32 4.64 11 16.49 13.49l13 10.65 13.83 6.27 5.64 2.55 2.39-17.27-5.43-3-6.33-3.46s-14.28-25.87-36.89-15a5 5 0 00-2.7 5.77z"
        opacity={0.1}
      />
      <path
        d="M646.67 333.6c1.06 4.33 4.63 11 16.48 13.49l13 10.65 13.84 6.27 5.63 2.55 2.39-17.27-5.43-3-6.28-3.43s-14.29-25.87-36.9-14.95a5 5 0 00-2.73 5.69z"
        fill="#cc818c"
      />
      <circle cx={672.15} cy={213.73} r={31.59} opacity={0.1} />
      <circle cx={672.15} cy={213} r={31.59} fill="#cc818c" />
      <path
        d="M691.72 280.5l-9.5-18.46s13.9-5.62 14.91-12.13 13.32 7.63 10.66 12.32-16.07 18.27-16.07 18.27z"
        opacity={0.1}
      />
      <path
        d="M691.72 279.03l-9.5-18.46s13.9-5.62 14.91-12.13 13.32 7.64 10.66 12.32-16.07 18.27-16.07 18.27z"
        fill="#6c63ff"
      />
      <path
        d="M613.97 326.72l52.49 70.57s-19.35 10.53-46-8.32l-11.51-13.72-32.86-55.39z"
        fill="#f6f8fb"
      />
      <path
        d="M603.64 365.09l4.78-.13s29.2-28.34 36.37-14-18.19 27.74-18.19 27.74l-7.71 4.16-10.05 3-6.43-8.63z"
        fill="#cc818c"
      />
      <path
        d="M610.69 380.4c.44 1.63.86 3.43.12 4.94a2 2 0 01-.87.95 2.23 2.23 0 01-1 .14 10.05 10.05 0 01-6.59-3.26 30.1 30.1 0 01-4.27-6.18c-1.3-2.27-2.65-4.78-2.19-7.36.52-2.81 3-4.76 5.43-6.34 4.84-3.2 5 .53 6.06 4.65s2.2 8.3 3.31 12.46z"
        opacity={0.1}
      />
      <path
        d="M609.96 380.4c.43 1.63.86 3.43.12 4.94a2 2 0 01-.87.95 2.25 2.25 0 01-1 .14 10 10 0 01-6.59-3.26 29.75 29.75 0 01-4.28-6.18c-1.3-2.27-2.65-4.78-2.18-7.36.51-2.81 3-4.76 5.42-6.34 4.85-3.2 5 .53 6.07 4.65s2.19 8.3 3.31 12.46z"
        fill="#6c63ff"
      />
      <path
        opacity={0.1}
        d="M623.85 317.94l2.44-4.13-2.13 7.67-.31-3.54zM690.03 364.01l5.63 2.55 2.39-17.27-5.43-3c3.75 4.3.47 12.25-2.59 17.72zM712.63 343.96s-18.18 1.11-25.9-3.85"
      />
      <g opacity={0.1}>
        <path d="M710.37 355.56a51.18 51.18 0 019.13-11.85 24.37 24.37 0 012.69-1.46l28.34-5.82 1.64-.36s.25-55.35-19.34-62.95a117.72 117.72 0 01-30.56-17.21l2.15-.66s11.75 10.28 31.35 17.87 19.34 62.95 19.34 62.95h-2.94l-29 5.55s-1.25 1.21-1.63 1.56a56.2 56.2 0 00-9.27 12.26 30.74 30.74 0 00-2.43 23.24h-3c-2.42-8.77.08-16.88 3.53-23.12zM632.97 257.86c.47-.07.92-.14 1.41-.19a50.71 50.71 0 006 .49 54.54 54.54 0 01-7.41-.3zM674.54 263.57l-17.94-9.08a9.48 9.48 0 001-.95l18.72 9.47z" />
      </g>
      <path
        d="M742.84 319.86l12 14.7 2.45 39.92s3.18 20.32-20.08 15.42-50.18-20.04-50.18-20.04 13-17.39 5.88-24l33.31 10.78s5.63-1.23 1.22-6.12-5.19-13.72-5.19-13.72z"
        fill="#6c63ff"
      />
      <path
        d="M748.26 362.03l6.61 7.59a9.53 9.53 0 01-6.61-7.59zM736.99 360.8l10.29 13.22-5.14 1.23-5.15-14.45zM634.42 198.5c-1.13-2.77-.26-6 1.1-8.61s3.23-5.08 4.25-7.89c1.51-4.18 1.05-8.91 2.7-13 2.91-7.25 11.18-10.49 18.59-13 2.19-.73 4.52-1.46 6.76-.92 3 .71 4.95 3.43 7.4 5.26 10.06 7.5 26.42-.76 36.15 7.18 3.72 3 5.53 7.91 6.09 12.68s0 9.61-.06 14.42c-.16 8.42 1.42 17.63 7.72 23.21 1.9 1.68 4.14 2.94 6 4.68s3.32 4.17 3 6.69a23.19 23.19 0 01-1 3.4c-1.25 4.39.62 9 2.9 13 6.8 11.77 18.79 21.47 32.38 21.74-.91 6.86-8 10.84-14.35 13.65-8 3.59-16.52 7.11-25.33 6.66s-18-6.09-19.54-14.77c-.53-3-.46-6.61-3-8.17-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.16 56.16 0 01-2.61-16c-.11-6.44.74-13.47-2.91-18.77-3.38-4.91-9.38-7.4-13.28-11.91-3.6-4.18-7.51-9.22-13.41-10-8.16-1.15-25.04 9.94-29.86-1.87z"
        opacity={0.1}
      />
      <path
        d="M634.42 197.03c-1.13-2.77-.26-6 1.1-8.61s3.23-5.08 4.25-7.89c1.51-4.18 1.05-8.91 2.7-13 2.91-7.26 11.18-10.5 18.59-13 2.19-.73 4.52-1.46 6.76-.92 3 .71 4.95 3.43 7.4 5.26 10.06 7.5 26.42-.76 36.15 7.18 3.72 3 5.53 7.91 6.09 12.69s0 9.6-.06 14.41c-.16 8.42 1.42 17.63 7.72 23.21 1.9 1.68 4.14 2.94 6 4.68s3.32 4.17 3 6.69a23.19 23.19 0 01-1 3.4c-1.25 4.39.62 9 2.9 13 6.82 11.73 18.76 21.46 32.35 21.73-.91 6.86-8 10.84-14.35 13.66-8 3.58-16.52 7.1-25.33 6.65s-18-6.09-19.54-14.77c-.53-3-.46-6.61-3-8.17-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.1 56.1 0 01-2.61-16c-.11-6.44.74-13.47-2.91-18.77-3.38-4.91-9.38-7.4-13.28-11.91-3.6-4.18-7.51-9.22-13.41-10-8.13-1.14-25.01 9.97-29.83-1.86z"
        fill="#585268"
      />
      <path
        d="M656.84 278.21l18.11-14.7s-12.4-6.72-13.88-12.45-11.4 2.72-10.39 7.86 6.16 19.29 6.16 19.29z"
        opacity={0.1}
      />
      <path
        d="M657.55 276l18.11-14.69s-12.4-6.72-13.82-12.45-11.4 2.72-10.39 7.86 6.1 19.28 6.1 19.28z"
        fill="#6c63ff"
      />
      <circle cx={676.37} cy={273.61} r={1.44} opacity={0.1} />
      <circle cx={676.37} cy={281.61} r={1.44} opacity={0.1} />
      <circle cx={676.37} cy={289.6} r={1.44} opacity={0.1} />
      <g opacity={0.1}>
        <path d="M641.73 176.61c1.43-3.93 1.12-8.34 2.46-12.3a13.44 13.44 0 00-1.53 2.82c-1.66 4.13-1.19 8.86-2.71 13l-.1.24a22.85 22.85 0 001.88-3.76zM755.98 275.6c-8 3.58-16.52 7.1-25.33 6.65s-18-6.09-19.54-14.76c-.53-3-.46-6.62-3-8.18-1.56-.95-3.58-.71-5.26-1.42-2.43-1-3.63-3.73-4.43-6.24a56.1 56.1 0 01-2.61-16c-.11-6.43.75-13.46-2.9-18.77-3.39-4.91-9.39-7.39-13.29-11.91-3.6-4.17-7.51-9.22-13.41-10-8.09-1.1-25 10-29.78-1.82a9.3 9.3 0 01.31-6.83c-.35.59-.69 1.18-1 1.78-1.36 2.66-2.22 5.85-1.09 8.62 4.81 11.8 21.69.71 29.78 1.82 5.9.8 9.81 5.85 13.41 10 3.9 4.52 9.9 7 13.28 11.92 3.66 5.3 2.8 12.33 2.91 18.76a56.1 56.1 0 002.61 16c.8 2.52 2 5.22 4.43 6.24 1.68.71 3.7.48 5.26 1.42 2.58 1.56 2.51 5.21 3 8.18 1.56 8.67 10.74 14.31 19.54 14.76s17.28-3.06 25.33-6.65c5.8-2.58 12.26-6.15 14-12-2.78 3.8-7.7 6.42-12.22 8.43z" />
      </g>
      <path
        d="M963.87 352.18C942.7 340 934.7 337 934.66 337l-.44-.31a17.61 17.61 0 01-5.33-6.74 14.07 14.07 0 010-1.45.61.61 0 000 .14c.33-6.45 4.92-12.32 9.27-17.44l11.13-13.09a12.9 12.9 0 002.87-4.54 10.47 10.47 0 00.3-2.79v-1.14c-.06-3.25-.15-6.51-.27-9.76-.1-2.84-.83-6.42-3.67-7-1.48-.3-3.44.23-4.22-1a2.43 2.43 0 01-.19-1.69.58.58 0 000 .14v-.16a37.67 37.67 0 001.05-6.69 9.12 9.12 0 00-.46-3.39c-1.64-4.71-7.31-6.65-12.32-7.54s-10.63-1.65-13.77-5.57a40.73 40.73 0 00-2.74-3.77 10.81 10.81 0 00-5.12-2.53 29 29 0 00-18.63 1.62c-2.42 1.08-4.85 2.54-7.51 2.38s-5.12-2.08-7.84-2.54c-4.4-.75-8.61 2.48-10.78 6.31a15.43 15.43 0 00-2 7.44v.44a10.88 10.88 0 002.86 7.6c1.9 2 4.72 3.32 5.51 5.91.32 1.05.24 2.19.53 3.26a2.91 2.91 0 00.12.39l-.14.19a33 33 0 00-7 20.34 33.76 33.76 0 0023.72 32v1c0 4-1.15 8.17-4.6 11.2L855 350.2s-18.08-2.15-24.6 24.27a45.05 45.05 0 00-1.12 13.4c.24 4-.31 11-5 20.07-7.41 14.52-5.72 47.85 9.44 51.15 14.31 3.12 19.91 1.82 20.5 1.67v.58c-.24 6.26-2.51 60.2-10.76 66.72-2.28 1.81-1.86 3 0 3.85 0 0 0 .35-.05 1-.25 4-1.52 19-7 27.52-6.41 9.9-5.74 67-5.74 67l-4.37 33.66s2.69 20.79 0 24.42c-2.41 3.23-5.61 80.14-6.28 96.82h-.28a8.12 8.12 0 00-6.48 4c-3.54 5.75-15.94 16.38-15.94 16.38-2.69 3.82-12.64 7.48-17.9 9.2a11.12 11.12 0 00-2 .88 10.67 10.67 0 00-4.52 4.76 5.11 5.11 0 00-.48 4c1.34 3.29 29.31 5.61 36.39 2.3 5.56-2.59 27.6-6 36.75-7.34a7.54 7.54 0 006.54-6.54 4.31 4.31 0 00-.84-3.27c-1.75-2.17-2.64-8.1-3-12a8.11 8.11 0 002.06-1.22 87.85 87.85 0 015-35.31c6.74-17.82 8.76-50.82 7.08-72.27 0 0 20.55-88.44 36.73-96.69.25.32 8.1 10.39 9.1 41.58 1 31.68 12.46 52.47 12.46 52.47s-5.06 53.79 0 73.92l-6.61 31.75c-.49-.41-.8-.73-.8-.73s.2.88.47 2.29l-.14.68.29.06c.75 4 1.86 10.89 1.4 15-.26 2.31-.91 5.48-1.35 8.59-.7 4.89-.89 9.63 1.68 10.67 4.22 1.7 29 4 33.2-1.44a7.79 7.79 0 001.22-8.15 8.25 8.25 0 00-1.22-2.08s-6.58-10.75-4.72-18.33a5.58 5.58 0 00-.79-4.35c.29-3.72 1.79-20.94 5.67-35.56 4.22-15.88 13.11-50.7 6.57-73.59q-.37-1.35-.84-2.64a98.84 98.84 0 01-3.71-38.61 78.69 78.69 0 010-33.66c4.05-18.48 6.88-36.63 6.88-36.63s2.23-24.42.28-39.39c0-.32-.09-.64-.13-1l1.06-.24s-5.73-25.41-7.75-41.58c-.48-3.82-1.1-8.65-1.78-13.81a35.25 35.25 0 005.49-1.37c18.19-6.27 23.92-63 23.92-63v-18s6.12-27.67-15.11-39.88zM828.31 790.42c-.56-.28-.89-.47-.89-.47z"
        transform="translate(-31.16 -20.14)"
        fill="url(#prefix__c)"
      />
      <path
        d="M921.73 659.57c7.89 22.69-1.32 59.52-5.6 76s-5.59 36.18-5.59 36.18c-16.77 2.63-28.94-.66-28.94-.66l6.91-33.87c-4.94-20.06 0-73.67 0-73.67s-11.18-20.72-12.17-52.29c-1-31.07-8.63-41.12-8.87-41.43-15.78 8.22-35.84 96.36-35.84 96.36 1.64 21.37-.34 54.26-6.91 72a89 89 0 00-4.93 35.18c-2.3 2-5.5 2.28-9 1.72-9.39-1.52-20.65-9.61-20.65-9.61s3.61-96 6.25-99.64 0-24.34 0-24.34l4.27-33.54s-.66-56.9 5.59-66.76c5.4-8.52 6.64-23.5 6.88-27.43v-1l9.52-11.4s92.08-6.91 99 0c1.69 1.69 2.74 5.55 3.36 10.4 1.9 14.92-.28 39.25-.28 39.25s-2.76 18.09-6.71 36.5a80.12 80.12 0 000 33.55 100.43 100.43 0 003.71 38.5z"
        fill="#65617d"
      />
      <path
        d="M915.97 803.77c-4.11 5.43-28.28 3.13-32.4 1.44-2.51-1-2.32-5.77-1.64-10.64.43-3.09 1.06-6.25 1.32-8.55.65-5.92-2-17.93-2-17.93s5.42 5.76 6.73 0c.58-2.52 2.6-3.81 4.7-4.46a12.28 12.28 0 018.54.53c4.27 1.86 11.39 5.81 10.12 11.15-1.81 7.55 4.6 18.27 4.6 18.27a8.32 8.32 0 011.2 2.06 7.89 7.89 0 01-1.17 8.13z"
        fill="#a27772"
      />
      <path
        d="M915.97 803.77c-4.11 5.43-28.28 3.13-32.4 1.44-2.51-1-2.32-5.77-1.64-10.64 2.6 1.22 7 2.23 14.37 1.55a40.54 40.54 0 015.17-.16 120.23 120.23 0 0015.7-.32 7.89 7.89 0 01-1.2 8.13zM831.62 666.15c1.64 21.37-.34 54.26-6.91 72a89 89 0 00-4.93 35.18c-2.3 2-5.5 2.28-9 1.72 2-13.87 10.44-73.63 15.85-120.85 6.17-53.77 35-90.76 35-90.76l5.75 6.33c-15.7 8.24-35.76 96.38-35.76 96.38z"
        opacity={0.1}
      />
      <path
        d="M906.1 320.51l-4 19.73-19.67 33.05-24.25-10.36s-33-34.53-12.25-39.46a18.36 18.36 0 006.88-3.06c4.07-3.07 5.35-7.53 5.37-11.9a36.48 36.48 0 00-3.34-14.14l42.42-13.32a68.09 68.09 0 00-3 17.18c-.33 11.56 4 17.25 7.49 20a12.74 12.74 0 004.35 2.28z"
        fill="#fbbebe"
      />
      <path
        d="M897.22 281.05a68.09 68.09 0 00-3 17.18 32.29 32.29 0 01-2.47 2.63 33.56 33.56 0 01-33.54 7.65 36.48 36.48 0 00-3.37-14.14z"
        opacity={0.1}
      />
      <path
        d="M902.09 275.62a33.55 33.55 0 11-33.55-33.54 33.39 33.39 0 0133.55 33.54z"
        fill="#fbbebe"
      />
      <path
        d="M906.1 320.51l-4 19.73-19.67 33.05-24.25-10.36s-33-34.53-12.25-39.46a18.36 18.36 0 006.88-3.06c-3.74 10.28 11.7 31.67 11.7 31.67 1.8 2.65 5.92 1 5.92 1 9.95-1.51 28.26-30.12 31.25-34.88a12.74 12.74 0 004.42 2.31zM925.09 511.79c-5.84 1.33-38.15 8.48-50.4 6.69-13.48-2-39.69-3.28-39.69-3.28s-16.69.9-21.83-1.45v-1l9.52-11.4s92.08-6.91 99 0c1.73 1.73 2.78 5.59 3.4 10.44z"
        opacity={0.1}
      />
      <path
        d="M864.5 353.07s-17.35-24-10.81-33.4l-29.31 12s-17.64-2.14-24 24.19a45.81 45.81 0 00-1.09 13.36c.24 4-.3 11-4.83 20-7.23 14.47-5.59 47.69 9.21 51s20.05 1.64 20.05 1.64-2 60.18-10.52 67.09 21.8 5.26 21.8 5.26 26.21 1.32 39.7 3.29 51.3-6.91 51.3-6.91-5.59-25.32-7.57-41.43-6.59-50.43-6.59-50.43l33.54-45.44s5.92-27.46-14.8-39.63-28.51-15.15-28.51-15.15-20.82 33.9-31.67 35.54c.02 0-4.1 1.66-5.9-.98z"
        fill="#6c63ff"
      />
      <path
        d="M826.02 362.6s-.32 10.86 1.65 15.13 9.21 28 9.21 28h-16.45s8.88-9.54 8.23-14.15-2.64-28.98-2.64-28.98z"
        opacity={0.1}
      />
      <path
        d="M874.7 444.49s-36.32-8.88-39.7-16.44-12.71-24.49-12.71-24.49l3.83-5.16 17.66 13.86s21 16.77 30.92 18.42 0 13.81 0 13.81z"
        fill="#fbbebe"
      />
      <path
        d="M874.7 444.49s-36.32-8.88-39.7-16.44-12.71-24.49-12.71-24.49l3.83-5.16 17.66 13.86s21 16.77 30.92 18.42 0 13.81 0 13.81z"
        opacity={0.05}
      />
      <path
        d="M906.1 401.74v19.7h-3.16a92.07 92.07 0 00-44.72 11.58l-5.94 3.29-1.59.89-10.2-23 9.54-8.55h.49c2.33.23 12.42 1.07 16.7-.37 4.06-1.38 9.1-5.75 21.06-2.7 5.89 1.51 10.93 8.11 16.64 6.05z"
        fill="#fbbebe"
      />
      <path
        d="M937.84 365.86l6.57 7.4v17.93s-5.59 56.56-23.34 62.81-49.46-3.62-49.46-3.62-8.19-21.7-4.36-23 33.85-9.24 33.85-9.24-.42-33.18 6.15-43.05c0 0-4.27-30.91 10.53-31.57s20.06 22.34 20.06 22.34z"
        opacity={0.1}
      />
      <path
        d="M938.84 365.86l6.58 7.4v17.93s-5.59 56.56-23.35 62.81-49.46-3.62-49.46-3.62-8.19-21.7-4.35-23 33.85-9.24 33.85-9.24-.43-33.18 6.15-43.05c0 0-4.28-30.91 10.52-31.57s20.06 22.34 20.06 22.34z"
        fill="#6c63ff"
      />
      <path
        d="M892.89 289.86a13.22 13.22 0 00-.75-6.41c-.93-2-3.1-3.51-5.22-3-2.81.66-4 4.32-6.78 5.2-2.33.74-4.87-.91-6-3.08s-1.14-4.72-1.14-7.16v-8.24c0-3-.1-6.22-1.94-8.57-2.29-2.92-7.68-4.2-11.28-4.08a9.57 9.57 0 00-6.44 2.59c-1.92 1.64-4.15 2.84-6.77 2.41a5.83 5.83 0 01-4.72-4.08v-.1a33.54 33.54 0 1149.86 44.52 90.43 90.43 0 001.18-10z"
        opacity={0.1}
      />
      <path
        d="M846.57 258.55a5.88 5.88 0 01-4.73-4.09c-.27-1.06-.2-2.19-.51-3.24-.77-2.59-3.53-3.93-5.38-5.9-3.7-3.93-3.46-10.39-.84-15.12 2.12-3.81 6.22-7 10.52-6.28 2.66.46 5 2.35 7.66 2.53s5-1.29 7.33-2.37a27.62 27.62 0 0118.22-1.62 10.5 10.5 0 015 2.53 43.75 43.75 0 012.67 3.75c3.06 3.9 8.55 4.67 13.44 5.55s10.42 2.82 12 7.52c1.07 3.12 0 6.5-.58 9.74a2.94 2.94 0 00.13 2c.77 1.26 2.68.73 4.12 1 2.77.59 3.48 4.16 3.59 7q.17 4.86.26 9.73a12.39 12.39 0 01-.29 3.6 12.71 12.71 0 01-2.79 4.53l-10.86 13.05c-4.82 5.78-9.93 12.52-9 20-2.28 1-5-.95-5.74-3.34s-.15-5 .36-7.41a90.85 90.85 0 001.74-12.85 13.18 13.18 0 00-.75-6.4c-.93-2-3.1-3.51-5.22-3-2.82.66-4 4.32-6.78 5.2-2.33.74-4.87-.91-6-3.08s-1.14-4.71-1.14-7.15v-8.25c0-3-.1-6.22-1.94-8.57-2.29-2.92-7.68-4.2-11.28-4.08a9.57 9.57 0 00-6.43 2.59c-1.93 1.65-4.16 2.86-6.78 2.43z"
        fill="#7c5c5c"
      />
      <path
        d="M854.14 361.78l10.3 42.31s8.12-.05-10.3-42.31zM889.33 354.71s-13.48 22.08-8.22 44.92l2.51.18s-4.48-10.57 5.71-45.1zM897.84 479.68s16.56-5.48 17.76 7.23c.04 0-3.08-8.71-17.76-7.23zM850.03 406.67s-3.29 23 2.63 32.23c0 0-12 4.93-28.94 3.95l-2-36.18z"
        opacity={0.1}
      />
      <path
        d="M852.28 436.31l-1.59.89-10.2-23 9.54-8.55h.49c-.15 1.14-2.81 20.91 1.76 30.66z"
        opacity={0.1}
      />
      <path
        d="M850.03 405.69s-3.29 23 2.63 32.22c0 0-12 4.94-28.94 3.95l-11.51-36.17z"
        fill="#6c63ff"
      />
      <path
        d="M821.59 789.77a7.45 7.45 0 01-6.39 6.52c-8.93 1.33-30.44 4.73-35.87 7.32-6.91 3.29-34.2 1-35.52-2.3a5.22 5.22 0 01.47-4 10.54 10.54 0 014.41-4.74 11.7 11.7 0 012-.88c5.14-1.71 14.85-5.35 17.47-9.17 0 0 12.11-10.59 15.56-16.31a7.9 7.9 0 016.32-3.94c2.88-.13 6.09 1.32 7.41 7.63 0 0 15.77 9 20 1.11 0 0 .66 12.12 3.28 15.44a4.4 4.4 0 01.86 3.32z"
        fill="#a27772"
      />
      <path
        d="M821.59 789.77a7.45 7.45 0 01-6.39 6.52c-8.93 1.33-30.44 4.73-35.87 7.32-6.91 3.29-34.2 1-35.52-2.3a5.22 5.22 0 01.47-4 10.54 10.54 0 014.41-4.74c4.45 3 14.33 5.84 36.06 2.45 20.73-3.24 31-6.41 36-8.57a4.4 4.4 0 01.84 3.32z"
        opacity={0.1}
      />
      <g opacity={0.1}>
        <path d="M911.32 252.01v-.16c.47-2.46 1.18-5 1-7.47a49.31 49.31 0 01-1 6 3.64 3.64 0 000 1.63zM892.13 282.79a9.51 9.51 0 01.81 3.76 11.34 11.34 0 00-.81-5.24c-.92-2-3.09-3.51-5.21-3-2.82.66-4 4.32-6.79 5.2-2.32.74-4.86-.91-6-3.08s-1.14-4.72-1.14-7.16v-8.24c0-3-.1-6.22-1.94-8.57-2.3-2.93-7.68-4.2-11.28-4.09a9.58 9.58 0 00-6.44 2.6c-1.93 1.64-4.15 2.84-6.78 2.41a5.86 5.86 0 01-4.72-4.08c-.27-1.06-.2-2.2-.51-3.25-.77-2.58-3.53-3.93-5.38-5.89a10.77 10.77 0 01-2.77-7 11.21 11.21 0 002.77 8.43c1.85 2 4.61 3.31 5.38 5.89.31 1 .24 2.19.51 3.25a5.86 5.86 0 004.72 4.08c2.63.43 4.85-.77 6.78-2.41a9.58 9.58 0 016.44-2.6c3.6-.11 9 1.16 11.28 4.09 1.84 2.35 1.93 5.58 1.94 8.57v8.24c0 2.44 0 5 1.14 7.15s3.65 3.83 6 3.09c2.76-.88 4-4.54 6.79-5.2 2.12-.46 4.29 1.12 5.21 3.05zM919.16 273.74a12.64 12.64 0 01-2.8 4.52l-10.86 13.05c-4.57 5.49-9.4 11.85-9 18.86.33-6.43 4.81-12.28 9-17.38l10.86-13.05a12.64 12.64 0 002.8-4.52 12.48 12.48 0 00.29-3.61 9.5 9.5 0 01-.29 2.13zM890.84 307.97a7.69 7.69 0 01-.33-1.76 8.87 8.87 0 00.33 3.24c.74 2.38 3.45 4.35 5.74 3.33a14 14 0 01-.12-1.44c-2.28.91-4.92-1.03-5.62-3.37z" />
      </g>
      <path
        d="M781.53 769.22s3.44 6 15.9.72M886.84 770.68s10.74 12.65 24.28 4.15M918.1 621.09s-7.59 4.74-7.83 7.45 3.92-2 3.92-2zM921.1 657.45a15.87 15.87 0 01-9.35 3.65c-5.68.25-5.2 7.65-1.49 5.43s10.84-9.08 10.84-9.08zM922.54 662.2s-3.64 17.89-6.6 14.44"
        opacity={0.1}
      />
      <path
        d="M250.48 816.42s22.85 6.27 33.85-2.07 15.77-5.66 15.77-5.66 26.23-1.45 28.39-7.65-10.06-28.72-10.06-28.72c-.87-2-2.14-4.54-2.71-4.54l.12-9.5 3.8-39.75c8.77-22.49.16-51.55.16-51.55l-1.57-7.21a18.24 18.24 0 011.49-12l15.93-32a47.88 47.88 0 013-6.14c1-1.83 2.33-4.09 4-6.8.49-.78 1-1.59 1.56-2.44 1.93-3 4.27-6.4 7.1-10.32 7.05-9.77 10.76-22 12.68-31l.85 2.82h.19l.23.05h.38l.41.07h.15l4.9 62.36c.3 24.32 9.23 37.78 9.23 37.78l-1.23 53.69c1.68 12.93-2 30.17-3.69 37.05l-3.86 8.71a10.47 10.47 0 00-5.69 7.92c-.76 6.43-7.53 20.29-7.53 20.29-2.62 3.32-8.31 12.29-8.31 12.29s-2.68 8.66-1.02 11.9 15.54 2.91 15.54 2.91c15.85 3.51 28-5 27.23-10.86s2.47-7.35 2.47-7.35c6.3-2 5.69-6.27 5.69-6.27a39.24 39.24 0 00-4.77-25.54l-1 2.31a35.17 35.17 0 011.9-13.63l-.58.4-.18.11h-.06c1-8.77 10.21-25 10.21-25 16.92-29.68 10.77-69.9 10.77-69.9l-2.62-12.54-.15-4.73a157.87 157.87 0 012.55-33.7c.91-4.92 1.85-10.86 2.57-17.41 1.52-13.84 6.42-28.12 8.68-34.17l.67-.12h.08c.92-.16 1.85-.32 2.79-.5h.18s.54-2.92 1-7.89c.27-3.17.49-7.19.49-11.81a132.87 132.87 0 00-6.31-41.11l.51-.73s1.21-1.64 3.42-4.48c4.06-5.16 10.38-13 18.17-21.84 13.95-15.91 9.85-32 9.85-32s-10.1-37.01-14.6-59.23c-2.57-12.66-7.39-21.27-11.08-26.35a52.44 52.44 0 001.4-10.68c.3-6.58.07-13.44-2.89-19.35s-9.26-10.58-15.84-9.79a6.06 6.06 0 01-2.84 0 4.32 4.32 0 01-1.87-1.63c-3.85-5.31-4.1-12.45-2.9-18.89s3.66-12.6 4.76-19.06.6-13.63-3.51-18.75c-4.83-6-13.25-7.69-19.53-12.2-4.41-3.17-7.72-7.72-12.37-10.53s-9-1.74-14.05-.68c-8.49 1.79-16.56 2.61-24.59 6.26a65.49 65.49 0 00-21.43 15.59 20.34 20.34 0 00-4.78 7.54c-2 6.61 1.91 13.65 1.09 20.49-.58 4.85-3.44 9.07-5.71 13.4s-4 9.47-2.22 14c2.8 7.08 11.93 8.58 18.57 12.35a5.67 5.67 0 012.2 1.91c1.64 2.86-1.71 5.83-3.82 8.37a12.61 12.61 0 00-2.5 5.08 18.12 18.12 0 00-10.87 13.12c-2.25 10.07 1.21 22.78 4.26 31.18-3.33 18.71 1 26.09 4.19 28.92a16.05 16.05 0 015.56 10.94v.35c.21 3.4.57 6.79 1.05 10.17-.11-.79-.22-1.63-.28-2-2.61 4.83-7.58 17.17-10.38 37.93a114 114 0 01-2.53 13.21 72.24 72.24 0 00-2.12 23.62l.5 6.73a2.12 2.12 0 01-1.36-.45l3.51 6.43V527a40 40 0 01-2.66 14.31c-.25.66-.52 1.32-.81 2a11.64 11.64 0 00-1.18 5.89c-7.55 11.57-24.86 76.41-24.86 76.41-9.39 21.26.77 35 .77 35s4.92 59.19 5.84 62.25 2.96 39.14 2.96 39.14v2.87a6.73 6.73 0 00-1.71-.49c-8.23-.46-10.46 12.54-10.46 12.54L262.17 793s-7.69-1.3-19 7.19 7.31 16.23 7.31 16.23zm168.15-342.09l-.05-.18-.46.27-.19.11-.09.06-7.76-27.39a45.48 45.48 0 01-.57-22.53l6-26.28v-6.32l19.07 50.82c1.22 6.85-10.11 23.44-15.95 31.44z"
        transform="translate(-31.16 -20.14)"
        fill="url(#prefix__d)"
      />
      <path
        d="M395.84 536.86s-7.7 18.73-9.66 36.7c-.71 6.48-1.63 12.34-2.53 17.2a157.18 157.18 0 00-2.46 33.27l.15 4.67 2.5 12.37s6 39.73-10.57 69c0 0-9.82 17.53-10.12 25.83l-6.65 2.57-13.44-3.77s6.49-23.27 4.38-39.58l1.21-53s-8.73-13.26-9.03-37.26L334.49 539zM334.49 527.48s-1.65 25.68-14.35 43.38-15.4 25.38-15.4 25.38l-15.64 31.62a18.11 18.11 0 00-1.47 11.83l1.54 7.12s8.46 28.7-.15 50.91l-4.08 42.9h-23.86s-2-35.65-2.87-38.67-5.74-61.48-5.74-61.48-10-13.6-.76-34.59c0 0 20.85-78.55 26.43-77.19s56.35-1.21 56.35-1.21z"
        fill="#fdc2cc"
      />
      <path
        d="M286.75 646.86l-1.53-7.12a18 18 0 011.46-11.88l15.64-31.65s2.71-7.7 15.4-25.38c12.19-17 14.2-41.36 14.34-43.23l2.43-.12s-1.65 25.68-14.35 43.38-15.4 25.38-15.4 25.38l-15.64 31.62a18.11 18.11 0 00-1.47 11.83l1.54 7.12s8.46 28.7-.15 50.91l-4.08 42.9h-2.42l4.08-42.9c8.61-22.21.15-50.86.15-50.86zM360.77 735.93c.3-8.3 10.12-25.83 10.12-25.83 16.62-29.3 10.57-69 10.57-69l-2.56-12.38-.15-4.67a157.18 157.18 0 012.46-33.27c.89-4.86 1.81-10.72 2.52-17.2 1.89-17.3 9.1-35.3 9.63-36.62l2.48-.1s-7.7 18.73-9.66 36.7c-.71 6.48-1.63 12.34-2.53 17.2a157.18 157.18 0 00-2.46 33.27l.15 4.67 2.5 12.37s6 39.73-10.57 69c0 0-9.82 17.53-10.12 25.83l-6.65 2.57-1.4-.39z"
        opacity={0.1}
      />
      <path
        d="M353.07 735.63a11.56 11.56 0 0011-1.36 35.5 35.5 0 00-.9 19.94c2.72 10.88-25.38-8.76-25.38-8.76l6-13.71s2.33 4.34 9.28 3.89z"
        fill="#d39999"
      />
      <path
        d="M355.16 736.24a11.23 11.23 0 008.93-2 35.5 35.5 0 00-.9 19.94c2.72 10.88-25.38-8.76-25.38-8.76l6-13.71s1.74 3.34 6.85 3.86c1.55.18 3.03.39 4.5.67z"
        opacity={0.1}
      />
      <path
        fill="#fdc2cc"
        d="M289.32 481.5h11.74v-66.61l-8.81-1.58-2.93 68.19z"
      />
      <path
        opacity={0.05}
        d="M289.32 481.5h11.74v-66.61l-8.81-1.58-2.93 68.19z"
      />
      <path
        d="M346.42 740.77s7.4-.46 10.72 6.19l4.08 3.17 2-4.68a39 39 0 014.62 25.23s.6 4.22-5.59 6.19c0 0-3.17 1.51-2.42 7.25s-11.17 14.2-26.73 10.72c0 0-13.6.31-15.26-2.87s1.06-11.63 1.06-11.63 5.59-8.86 8.15-12.13c0 0 6.65-13.7 7.41-20s8.03-10.92 11.96-7.44z"
        fill="#7e5659"
      />
      <path
        d="M285.17 746.36l.12-9.39s-13.51 3.89-24.45-.51c0 0 .92 9.44-.6 10.73s5.06 13.44 5.06 13.44l7.35 7.7 12.64-4.6 3.43-10.8s-2.65-6.57-3.55-6.57z"
        fill="#d39999"
      />
      <path
        d="M285.17 746.36l.12-9.39s-13.51 3.89-24.45-.51c0 0 .92 9.44-.6 10.73s5.06 13.44 5.06 13.44l7.35 7.7 12.64-4.6 3.43-10.8s-2.65-6.57-3.55-6.57z"
        opacity={0.1}
      />
      <path
        d="M259.41 742.96s7.18.83 6.27 10 .38 0 .38 0 7.63 3.09 10.35 7.4 7.63-3.85 8-6.19 3.43-3.31 3.43-3.31 12 22.25 9.88 28.37-27.88 7.53-27.88 7.53-4.69-2.64-15.49 5.59-33.23 2-33.23 2-18.28-7.63-7.17-16 18.65-7.1 18.65-7.1l16.54-15.94s2.19-12.81 10.27-12.35z"
        fill="#7e5659"
      />
      <path
        d="M345.16 216.95c4.57 2.77 7.82 7.27 12.15 10.4 6.16 4.45 14.43 6.11 19.17 12.05 4 5.06 4.52 12.13 3.44 18.51s-3.5 12.47-4.67 18.83-.93 13.41 2.85 18.65a4.23 4.23 0 001.83 1.61 6 6 0 002.79 0c6.46-.78 12.66 3.84 15.56 9.67s3.13 12.61 2.83 19.11c-.25 5.33-.85 10.77-3.19 15.57-4 8.16-12.32 13.2-20.53 17.06a159 159 0 01-16.39 6.62c-3.84 1.3-7.89 2.47-11.88 1.79-6.83-1.18-11.67-7.39-18.15-9.82-5.31-2-11.2-1.28-16.85-.78-4.82.42-10.33.41-13.65-3.11-4.26-4.52-2.34-11.81-.16-17.63a12.55 12.55 0 01-8.88-20.52c2.06-2.51 5.35-5.44 3.74-8.27a5.48 5.48 0 00-2.16-1.88c-6.51-3.72-15.48-5.21-18.22-12.19-1.76-4.49-.06-9.57 2.17-13.84s5-8.45 5.61-13.23c.8-6.76-3-13.71-1.07-20.23a20.28 20.28 0 014.69-7.46 64.36 64.36 0 0121-15.39c7.89-3.61 15.8-4.42 24.14-6.18 5-1.06 9.14-2.18 13.83.66z"
        fill="#865a61"
      />
      <path
        d="M301.05 317.62s-19.13-1-22.75 15.31 7.85 39.67 7.85 39.67z"
        fill="#fdc2cc"
      />
      <path
        d="M301.05 317.62s-19.13-1-22.75 15.31 7.85 39.67 7.85 39.67z"
        opacity={0.05}
      />
      <path
        d="M288.84 366.16l7.25 5.74 33.83 1.51 21.12-14.5 21.48-36.86c-13.13-3.35-18.44-12.42-20.42-20.9a45.76 45.76 0 01-.42-17.46s-34.44-17.83-30.21 10a37.8 37.8 0 01.32 10.34c-2 16.3-17.82 13.23-17.82 13.23l-6.07 9.36-6.95 23z"
        fill="#fdc2cc"
      />
      <path
        d="M321.5 293.65a37.8 37.8 0 01.32 10.34 30.53 30.53 0 0030.31-2.84 45.76 45.76 0 01-.42-17.46s-34.44-17.83-30.21 9.96z"
        opacity={0.1}
      />
      <circle cx={334.51} cy={275.03} r={30.51} fill="#fdc2cc" />
      <path
        d="M312.93 360.34c.74 0 1.47.11 2.2.18 4 .4 20.71 1.3 30.23-10.07 10.65-12.72 24.83-28.43 25.41-29.07l14.43 4.36s-11.42-4.06-19 17.18a22 22 0 007.43 25.31 22.86 22.86 0 009.44 4 .05.05 0 010 .05v9.32l-5.9 26a45.07 45.07 0 00.56 22.25l9 31.81c-1.36.94-57.2 38.92-94.5 12.69.14-1.14 4.75-38.47 1.55-56.74a126.16 126.16 0 01-1.67-14.12v-.35a15.92 15.92 0 00-5.47-10.8c-3.36-3-7.91-11-3.41-32.14a77.66 77.66 0 015-15.23l12.51-28.27 11.53.23v.08c-1 1.24-14.37 17.94-15.82 28.7-1.42 10.23-3.17 13.37 16.48 14.63z"
        fill="#6c63ff"
      />
      <path
        d="M394.91 330.71s11.28 9.67 15.71 31.62 14.3 58.41 14.3 58.41 4 15.91-9.67 31.62-22.76 28-22.76 28l-9 13.26a11.29 11.29 0 01-6.48 4.58c-4.1 1.08-10.4 1.86-15.86-1.13a9.24 9.24 0 01-4-11.67l2-4.63s-18.53 11.68-20.14 5.23 21.55-12.89 21.55-12.89 19.13-3.22 23-12.28c0 0 20.54-26.39 18.93-35.45l-19.84-53.17s-24.81-3.28-16.35-31.15 28.61-10.35 28.61-10.35z"
        fill="#fdc2cc"
      />
      <path
        d="M276.28 531.31s45.32 9.06 56 7.85l1.15 3.83s17.2 3.85 56.09-2.32q3.81-.6 7.91-1.35l.91-.16s.53-2.88.95-7.79c.93-11.15 1.26-32.74-6.59-54.84l-6.54-20.14s-40.42 24.23-67.18 22c-2.39-.2-4.76-.39-7.15-.47-5.49-.21-14 0-19.53-4.43l-11.6 2v33a39.54 39.54 0 01-2.62 14.12c-.25.66-.51 1.31-.8 2a10.5 10.5 0 00-1 6.7z"
        fill="#65617d"
      />
      <path
        d="M333.42 532.72v10.27s19.8 4.43 64.91-3.83c0 0 .53-2.88.95-7.79-13.84 2.22-52.01 7.56-65.86 1.35z"
        opacity={0.1}
      />
      <path
        d="M276.28 531.31s45.32 9.06 56 7.85l1.15 3.83v-10.27c-5.16 2.14-42-6.74-55.35-10.07-.25.66-.51 1.31-.8 2a10.5 10.5 0 00-1 6.66z"
        opacity={0.1}
      />
      <path
        d="M386.15 519.86l3.36 20.84q3.81-.6 7.91-1.35c-1.05-6.09-3.34-20-2.71-22.31l-4.23-3.62z"
        fill="#65617d"
      />
      <path
        d="M386.62 519.41l3.36 20.85q3.81-.61 7.91-1.35c-1.05-6.09-3.34-20-2.71-22.31l-4.23-3.63z"
        opacity={0.1}
      />
      <g opacity={0.05}>
        <path d="M316.55 478.38c-2.38-.2-4.76-.39-7.15-.47-5.34-.2-13.49 0-19.05-4.09l1.94-.34c5.56 4.41 14 4.22 19.53 4.43 2.39.08 4.76.27 7.15.47.78.07 1.58.11 2.39.13a44.87 44.87 0 01-4.81-.13zM387.09 540.67q3.81-.6 7.91-1.34l.92-.17s.53-2.88.94-7.79c.94-11.15 1.27-32.74-6.59-54.84l-6.16-19c1.31-.74 2-1.17 2-1.17l6.54 20.14c7.85 22.1 7.52 43.69 6.59 54.84-.42 4.91-.95 7.79-.95 7.79l-.91.17q-4.09.74-7.91 1.34c-18.17 2.88-31.59 3.58-40.75 3.5a257 257 0 0038.37-3.47zM329.84 539.16v.11h-1.3q.74-.05 1.3-.11z" />
      </g>
      <ellipse cx={391.78} cy={520.23} rx={1.71} ry={3.52} fill="#d39999" />
      <path
        d="M282.64 448.95c2.76-20.5 7.63-32.68 10.2-37.45.1.65.36 2.76.48 3.41.52 3 .06 6.78.22 10.59l-2.56 46.36 3.43 14.5c3.22 11.48-8.71 2.41-8.71 2.41-2.47 5.44-7 4.84-7 4.84l-.62-8.32a71.86 71.86 0 012.08-23.33 111.18 111.18 0 002.48-13.01z"
        fill="#fdc2cc"
      />
      <path
        d="M282.64 448.95c2.76-20.5 7.63-32.68 10.2-37.45.1.65.36 2.76.48 3.41.52 3 .06 6.78.22 10.59l-2.56 46.36 3.43 14.5c3.22 11.48-8.71 2.41-8.71 2.41-2.47 5.44-7 4.84-7 4.84l-.62-8.32a71.86 71.86 0 012.08-23.33 111.18 111.18 0 002.48-13.01z"
        opacity={0.05}
      />
      <path
        d="M397.42 473.96c-2.17 2.81-3.36 4.42-3.36 4.42l-9 13.25a11.24 11.24 0 01-6.48 4.58c-4.1 1.08-10.4 1.87-15.86-1.13a9.22 9.22 0 01-4-11.66l2-4.64s-18.53 11.68-20.14 5.24 21.55-12.89 21.55-12.89 19.13-3.22 23-12.29c0 0 1.67-2.14 4-5.42"
        fill="#fdc2cc"
      />
      <path
        d="M386.15 496.17s-21.91-2.13-28.85-14.66l-3.18 10.35s23 15.88 28.25 13.82z"
        fill="#65617d"
      />
      <path
        d="M385.37 496.07s-21.9-2.13-28.85-14.67l-3.17 10.32s23 15.88 28.24 13.82z"
        opacity={0.1}
      />
      <path
        d="M286.42 490.32s-7.67 2.72-9.18 1.21l3.45 6.35 6.52-5z"
        fill="#65617d"
      />
      <path
        d="M286.42 490.32s-7.67 2.72-9.18 1.21l3.45 6.35 6.52-5zM333.42 532.72v-13.25l-3.15 13.57 3.15-.32zM364.49 258.92c-1.85 2.6-5.06 3.92-8.22 4.33s-6.36.06-9.55 0c-5-.08-10.32.69-14.41 3.63-2.61 1.87-4.57 4.5-6.61 7-6.18 7.55-14.76 14.62-24.5 13.83a6.35 6.35 0 01-4.55-1.92 7.3 7.3 0 01-1.16-4.14 94.64 94.64 0 01.59-18.66 39.34 39.34 0 012.82-11.13 38 38 0 016.78-9.68 41.47 41.47 0 0111.83-9.48 21.22 21.22 0 0114.8-1.91c5.83 1.59 10.37 6.15 15.93 8.5 6.35 2.67 23.21 9.8 16.25 19.63z"
        opacity={0.1}
      />
      <path
        d="M364.49 257.71c-1.85 2.6-5.06 3.92-8.22 4.33s-6.36.06-9.55 0c-5-.09-10.32.68-14.41 3.62-2.61 1.87-4.57 4.5-6.61 7-6.18 7.55-14.76 14.62-24.5 13.83a6.31 6.31 0 01-4.55-1.92 7.27 7.27 0 01-1.16-4.14 94.64 94.64 0 01.59-18.66 39.34 39.34 0 012.82-11.13 37.74 37.74 0 016.78-9.67 41.33 41.33 0 0111.83-9.49 21.22 21.22 0 0114.8-1.91c5.83 1.59 10.37 6.15 15.93 8.5 6.35 2.68 23.21 9.79 16.25 19.64z"
        fill="#865a61"
      />
      <path fill="#fdc2cc" d="M292.3 473.47l-.08 3.65-.82-3.49.9-.16z" />
      <path
        opacity={0.05}
        d="M292.3 473.47l-.08 3.65-.82-3.49.9-.16zM369.42 339.15c-8.47 27.87 16.22 31.14 16.22 31.14l19.84 53.17c1.61 9.06-18.94 35.45-18.94 35.45-1.43 3.38-5 5.95-8.9 7.85a13.94 13.94 0 005.28-5.8s20.54-26.38 18.93-35.44l-19.84-53.18s-24.68-3.27-16.22-31.14c2.83-9.31 7-13.55 11.22-15.07-2.91 2.34-5.58 6.39-7.59 13.02z"
      />
      <g opacity={0.1}>
        <path d="M369.84 364.47a20.84 20.84 0 004 3.79 22.73 22.73 0 009.44 4v1.05a22.66 22.66 0 01-8.56-3.79 20.75 20.75 0 01-4.88-5.05zM293.12 404.34v.35a129.15 129.15 0 001.72 14.17c3 17.24-.93 51.47-1.49 56.2-.32-.21-.64-.41-1-.64.15-1.14 4.76-38.47 1.56-56.73a126.72 126.72 0 01-1.67-14.12v-.35a15.43 15.43 0 00-2.69-7.65 15.55 15.55 0 013.57 8.77zM311.53 318.06l-9.78-.19a.05.05 0 00-.05 0l-12.5 28.26a77.91 77.91 0 00-5 15.23c-3.64 17.1-1.35 25.62 1.43 29.83-3.13-3.69-6.36-12.1-2.33-31a77.09 77.09 0 014.95-15.24l12.59-28.26 11.53.23v.07c-.09.12-.4.5-.84 1.07zM385.23 325.73l.17.05z" />
        <path d="M381.64 325.57l-9.8-2.95h-.05c-.58.64-14.75 16.35-25.4 29.07-9.52 11.37-26.21 10.48-30.23 10.08-.73-.08-1.47-.14-2.2-.19-10.93-.7-15.23-2-16.67-4.76 2.05 2 6.56 3 15.76 3.56.74 0 1.47.11 2.2.18 4 .4 20.71 1.29 30.23-10.07 10.65-12.73 24.83-28.44 25.41-29.08l14.26 4.32a8.91 8.91 0 00-3.51-.16z" />
      </g>
      <path
        d="M265.61 757.49s-13.8 3.77-16.47-2.15M353.22 754.66s-16 4.13-19.7-2.26"
        opacity={0.1}
      />
      <path
        d="M615.1 765.85c.23-2 .56-4 .92-6 1.58-8.64-.83-16.88-2-20.28-.37-1.05-.64-1.64-.64-1.64-6.37-1.74-31.48 17.74-40.63 25.08-3.17 0-6.61.14-10.37.39-1.64.12-3.28.16-4.92.13h-6c-8.49-6.84-34.77-27.41-41.31-25.63 0 0-.27.59-.64 1.64-1.22 3.4-3.63 11.64-2.05 20.28.36 2 .69 4 .92 6 .49 4.39 2.33 12.82 9 18.51 1.43 10.4 6.78 24.07 10.9 32.37a23.18 23.18 0 001.4 4.57c-1.7 6.56-3.66 15.12-3.1 18 0 0-8.88-2.15-9.78 8.54v.33c-3.21 1.47-7.22 4.84-2.71 11.9a4.63 4.63 0 002.32 1.89c.8.28 1.58.28 1.5-.84l5.55 6.25s10.06 1.16 10.18-4.68l.59.09c1.35.2 2.76.37 4.21.52l.7 2.31s-7.55-.16-5.49 4.49c0 0 1.9 1.76 2.55 1.12 0 0-1 3.05 2.94 3.05 0 0 4.23 2.24 5.88.64s5.07-4 5.39-5c.09-.27.13-2.64.15-5.92h.65c8.43.2 17.38-.07 25.52-.51h.66c0 3.55.05 6.17.14 6.45.33 1 3.76 3.37 5.4 5s5.87-.64 5.87-.64c3.92 0 2.94-3.05 2.94-3.05.66.64 2.56-1.12 2.56-1.12 2.06-4.65-5.5-4.49-5.5-4.49l.9-3 4.17-.35.66-.06c-.4 6.35 10.17 5.13 10.17 5.13l5.56-6.25c-.09 1.12.69 1.12 1.49.84A4.59 4.59 0 00614 860c6.81-10.65-5.77-12.91-5.77-12.91a6.17 6.17 0 00-1.19-.19c0-.18 0-.37.05-.55a21.94 21.94 0 00.08-4.22c-.47-1.93-3.57-5-7.49-5.45-2.56-.32-2.61-12.08-2.35-20.23a23.27 23.27 0 00.4-4.64 24.48 24.48 0 00-1-7.43c5-8.48 9-17.37 9.45-20 6.59-5.74 8.43-14.14 8.92-18.53z"
        transform="translate(-31.16 -20.14)"
        fill="url(#prefix__e)"
      />
      <path
        d="M574.26 826.76c-.4 5.54-1.47 14.43-1.47 14.43s-4.45.54-11.33 1.16l-4.67.4c-3.58.29-7.6.57-11.85.81-7.85.43-16.47.7-24.6.5-4.06-.09-8-.3-11.65-.66-1.63-.16-3.21-.35-4.71-.57-9.32-1.39-16-4.05-16.57-8.72a27 27 0 01-.21-6c.87-10.5 9.42-8.38 9.42-8.38-.55-2.9 1.52-11.91 3.2-18.43 1.06-4.11 2-7.23 2-7.23l60.12-4h.2a2.94 2.94 0 012.94 3.09c-.36 7.21-.87 23.72 2.08 24.09 3.78.47 6.77 3.46 7.23 5.35a22.44 22.44 0 01-.13 4.16zM523.2 747.62s-22.67 27.29-33.59 19.73c-.26-.18-.51-.36-.75-.55-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57 2-19.91.36-1 .61-1.61.61-1.61 7.55-2.1 42.4 27.29 42.4 27.29z"
        fill="#6c63ff"
      />
      <path
        d="M511.02 750.14s-7.14 5-17.21 13.22a36.36 36.36 0 01-5 3.44c-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57 2-19.91 14.12.98 30.88 28.2 30.88 28.2z"
        fill="#6c63ff"
      />
      <path
        d="M511.02 750.14s-7.14 5-17.21 13.22a36.36 36.36 0 01-5 3.44c-7.34-5.56-9.27-14.52-9.78-19.07-.22-2-.54-3.93-.89-5.88-1.51-8.49.8-16.57 2-19.91 14.12.98 30.88 28.2 30.88 28.2z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M503.25 747.45s-3.81 2.69-9.19 7.06a19.35 19.35 0 01-2.64 1.83c-3.91-3-5-7.75-5.22-10.17-.11-1.06-.28-2.1-.47-3.15a21.86 21.86 0 011.11-10.62c7.47.52 16.41 15.05 16.41 15.05z"
        opacity={0.1}
      />
      <path
        d="M537.89 747.62s22.67 27.29 33.59 19.73c.25-.18.51-.36.75-.55 7.34-5.56 9.27-14.52 9.78-19.07.22-2 .54-3.93.88-5.88 1.52-8.49-.8-16.57-2-19.91-.36-1-.62-1.61-.62-1.61-7.53-2.1-42.38 27.29-42.38 27.29z"
        fill="#6c63ff"
      />
      <path
        d="M550.06 750.14s7.15 5 17.22 13.22a36.36 36.36 0 004.95 3.44c7.34-5.56 9.27-14.52 9.78-19.07.22-2 .54-3.93.88-5.88 1.52-8.49-.8-16.57-2-19.91-14.05.98-30.83 28.2-30.83 28.2z"
        fill="#6c63ff"
      />
      <path
        d="M550.06 750.14s7.15 5 17.22 13.22a36.36 36.36 0 004.95 3.44c7.34-5.56 9.27-14.52 9.78-19.07.22-2 .54-3.93.88-5.88 1.52-8.49-.8-16.57-2-19.91-14.05.98-30.83 28.2-30.83 28.2z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M557.89 747.43s3.79 2.68 9.13 7a18.31 18.31 0 002.63 1.82c3.89-2.95 4.92-7.7 5.19-10.11.11-1 .28-2.09.47-3.13a21.9 21.9 0 00-1.05-10.56c-7.48.54-16.37 14.98-16.37 14.98zM561.9 790.09c-2.86 4.52-5.9 8.6-8.68 11.06-9 8-47.86 4.82-50.38 4.41-.53-.09-1.63-1.66-3-4.21 1.06-4.11 2-7.23 2-7.23z"
        opacity={0.1}
      />
      <path
        d="M531.14 745.33c-1.58.11-3.16.15-4.75.12-8.11-.14-35.43.22-38.46 11.25-3.57 13 12.39 47.81 14.9 48.23s41.36 3.57 50.39-4.41 20.78-33 20.15-35.27c0 0 11.2-23.62-42.23-19.92z"
        fill="#6c63ff"
      />
      <path
        d="M530.28 766.41s-20-3.08-29.38 16.6a24 24 0 001.77 24.19c3.12 4.39 7.7 7.66 14.07 5 14.16-5.83 13.54-45.79 13.54-45.79z"
        opacity={0.1}
      />
      <path
        d="M529.65 765.15s-20-3.08-29.38 16.6a24 24 0 001.77 24.19c3.12 4.39 7.7 7.66 14.07 5 14.16-5.83 13.54-45.79 13.54-45.79z"
        opacity={0.1}
      />
      <path
        d="M529.65 765.78s-20-3.08-29.38 16.6a24 24 0 001.77 24.19c3.12 4.39 7.7 7.66 14.07 5 14.16-5.83 13.54-45.79 13.54-45.79z"
        fill="#6c63ff"
      />
      <path
        d="M529.65 765.78s-20-3.08-29.38 16.6a24 24 0 001.77 24.19c3.12 4.39 7.7 7.66 14.07 5 14.16-5.83 13.54-45.79 13.54-45.79z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M508.08 782.99s-2.73 2.52-1.68 3.15 1.68-3.15 1.68-3.15zM511.02 786.21s-1.49 3.29-.43 3.65 1.69-2.36 1.69-2.36zM504.43 791.18s-1.46 3.88 0 3.88 0-3.88 0-3.88z"
        fill="#3f2b3b"
      />
      <path
        d="M502.62 801.57s2.92 7.46 10.52 6.93M509.45 803.77s3 2.94 6.29.84"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path
        d="M532.84 766.41s20-3.08 29.38 16.6a24 24 0 01-1.77 24.19c-3.11 4.39-7.7 7.66-14.07 5-14.2-5.83-13.54-45.79-13.54-45.79z"
        opacity={0.1}
      />
      <path
        d="M533.43 765.15s20-3.08 29.38 16.6a24 24 0 01-1.77 24.19c-3.11 4.39-7.7 7.66-14.07 5-14.13-5.83-13.54-45.79-13.54-45.79z"
        opacity={0.1}
      />
      <path
        d="M533.43 765.78s20-3.08 29.38 16.6a24 24 0 01-1.77 24.19c-3.11 4.39-7.7 7.66-14.07 5-14.13-5.83-13.54-45.79-13.54-45.79z"
        fill="#6c63ff"
      />
      <path
        d="M533.43 765.78s20-3.08 29.38 16.6a24 24 0 01-1.77 24.19c-3.11 4.39-7.7 7.66-14.07 5-14.13-5.83-13.54-45.79-13.54-45.79z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M555 782.99s2.73 2.52 1.68 3.15-1.68-3.15-1.68-3.15zM552.06 786.21s1.49 3.29.43 3.65-1.69-2.36-1.69-2.36zM558.66 791.18s1.45 3.88 0 3.88 0-3.88 0-3.88z"
        fill="#3f2b3b"
      />
      <path
        d="M560.46 801.57s-2.92 7.46-10.52 6.93M553.64 803.77s-3 2.94-6.3.84"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path d="M522.04 822.77c.53-.1 10.5-4.41 20.78 0z" fill="#3f2b3b" />
      <path
        d="M503.98 842.86c-9.32-1.39-16-4.05-16.57-8.72a27 27 0 01-.21-6 13.46 13.46 0 013.56-1.3c1.69-.47 3.78-.15 8.19 1.11s4.09 6.45 5 13.22a5.59 5.59 0 01.03 1.69z"
        opacity={0.1}
      />
      <path
        d="M490.13 827.49s-12.12 2.22-5.56 12.68a4.47 4.47 0 002.24 1.85c.77.27 1.51.27 1.43-.83l5.36 6.14s10.7 1.26 9.76-5.51-.63-12-5-13.22-6.52-1.58-8.23-1.11z"
        fill="#6c63ff"
      />
      <path
        d="M493.02 834.53s2.57 5.87 6.14.94M487.12 836.86s1.33 5.56 6.37 1.42"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path
        d="M574.26 826.76c-.4 5.54-1.47 14.43-1.47 14.43s-4.45.54-11.33 1.16a5.81 5.81 0 010-1.16c.94-6.77.63-12 5-13.22 4.1-1.11 6.19-1.52 7.8-1.21z"
        opacity={0.1}
      />
      <path
        d="M575.36 827.49s12.13 2.22 5.57 12.68a4.51 4.51 0 01-2.24 1.85c-.77.27-1.52.27-1.44-.83l-5.35 6.14s-10.71 1.26-9.76-5.51.63-12 5-13.22 6.54-1.58 8.22-1.11z"
        fill="#6c63ff"
      />
      <path
        d="M572.48 834.53s-2.58 5.87-6.14.94M578.38 836.86s-1.34 5.56-6.38 1.42"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path
        d="M520.34 844.06c-4.06-.09-8-.3-11.65-.66l-3.63-12.22a7.93 7.93 0 01-.33-2.23 7.78 7.78 0 0115.55-.05c.04 4.76.08 10.79.06 15.16z"
        opacity={0.1}
      />
      <path
        d="M504.43 831.18l4.28 14.42s-7.28-.16-5.29 4.41c0 0 1.83 1.73 2.46 1.1 0 0-.95 3 2.83 3 0 0 4.08 2.21 5.66.63s4.89-3.94 5.21-4.88c.2-.62.14-12.68.07-21a7.76 7.76 0 00-7.77-7.7 7.77 7.77 0 00-7.45 10.02z"
        fill="#6c63ff"
      />
      <path
        d="M510.21 849.33s-3.18 3-1.5 4.77M508.84 847.42s-2.94 1-2.94 3.69"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path
        d="M560.55 828.95a7.91 7.91 0 01-.32 2.23l-3.39 11.57c-3.58.29-7.6.57-11.85.81 0-4.32 0-10.07.07-14.66a7.77 7.77 0 0115.54.05z"
        opacity={0.1}
      />
      <path
        d="M560.84 831.18l-4.28 14.42s7.29-.16 5.3 4.41c0 0-1.83 1.73-2.46 1.1 0 0 .94 3-2.84 3 0 0-4.08 2.21-5.66.63s-4.88-3.94-5.2-4.88c-.2-.62-.14-12.68-.07-21a7.76 7.76 0 017.77-7.7 7.77 7.77 0 017.44 10.02z"
        fill="#6c63ff"
      />
      <path
        d="M555.07 849.33s3.18 3 1.5 4.77M556.47 847.42s2.94 1 2.94 3.69"
        fill="none"
        stroke="#3f2b3b"
        strokeMiterlimit={10}
      />
      <path
        d="M529.66 762.63s-14.81-.47-15.28 11 23.14 6.61 23.14 6.61 9.92-1.33 8.19-8.3-5.34-8.68-16.05-9.31z"
        opacity={0.1}
      />
      <path
        d="M529.66 761.37s-14.81-.47-15.28 11 23.14 6.61 23.14 6.61 9.92-1.33 8.19-8.3-5.34-8.68-16.05-9.31z"
        opacity={0.1}
      />
      <path
        d="M529.66 762s-14.81-.47-15.28 11 23.14 6.61 23.14 6.61 9.92-1.33 8.19-8.3-5.34-8.68-16.05-9.31z"
        fill="#3f2b3b"
      />
      <path
        d="M496.62 819.78s5 1.78 6 5.19M567.12 817.26s-3.55 1.49-3.3 7.71"
        opacity={0.1}
      />
      <ellipse
        cx={527.78}
        cy={862.49}
        rx={2.31}
        ry={3.83}
        transform="matrix(.87 -.5 .5 .87 -391.69 359.3)"
        fill="#6c63ff"
      />
      <ellipse
        cx={600.25}
        cy={862.49}
        rx={3.83}
        ry={2.31}
        transform="rotate(-60 567.224 879.4)"
        fill="#6c63ff"
      />
      <ellipse
        cx={527.78}
        cy={862.49}
        rx={2.31}
        ry={3.83}
        transform="matrix(.87 -.5 .5 .87 -391.69 359.3)"
        fill="#fff"
        opacity={0.5}
      />
      <ellipse
        cx={600.25}
        cy={862.49}
        rx={3.83}
        ry={2.31}
        transform="rotate(-60 567.224 879.4)"
        fill="#fff"
        opacity={0.5}
      />
      <ellipse
        cx={192.6}
        cy={716.06}
        rx={26.93}
        ry={4.55}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse
        cx={86.51}
        cy={780.59}
        rx={26.93}
        ry={4.55}
        fill="#6c63ff"
        opacity={0.1}
      />
      <ellipse cx={58.47} cy={722.86} rx={40.21} ry={6.8} fill="#6c63ff" />
      <path
        d="M41.84 711.74a11.63 11.63 0 01-3.84-5.78c-.49-2.3.49-5.05 2.68-5.89 2.46-.94 5.09.76 7.08 2.48s4.28 3.69 6.89 3.33a10.49 10.49 0 01-3.24-9.82 4 4 0 01.9-2c1.36-1.46 3.84-.83 5.48.32 5.19 3.66 6.65 10.72 6.67 17.08.53-2.3.09-4.68.1-7s.66-5 2.64-6.22a8 8 0 014-1c2.34-.08 4.94.15 6.54 1.86 2 2.12 1.47 5.69-.26 8s-4.35 3.8-6.76 5.42a14.92 14.92 0 00-4.84 4.61 4.72 4.72 0 00-.36.82H50.91a40.44 40.44 0 01-9.07-6.21z"
        fill="#6c63ff"
      />
      <ellipse
        cx={1029.83}
        cy={754.12}
        rx={26.93}
        ry={4.55}
        fill="#6c63ff"
        opacity={0.1}
      />
      <path
        d="M1011.75 732.97s15.36-.47 20-3.77 23.62-7.23 24.77-1.94 23.09 26.29 5.74 26.43-40.29-2.7-44.91-5.52-5.6-15.2-5.6-15.2z"
        fill="#a8a8a8"
      />
      <path
        d="M1062.56 751.86c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38h-.51s1 12.39 5.59 15.2 27.57 5.66 44.91 5.52c5 0 6.74-1.82 6.64-4.46-.69 1.64-2.6 2.64-6.33 2.64z"
        opacity={0.2}
      />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.number.isRequired,
}

const TeamSpirit = styled(Icon)([], space, color, display)

TeamSpirit.displayName = 'TeamSpirit'

TeamSpirit.defaultProps = {
  size: 24,
}

export default TeamSpirit
